import { createSelector } from 'reselect'
import { createAction } from 'redux-starter-kit'
import {
  roleuser,
  questionType,
  test as testConstants,
  testTypes as testTypesConstants,
  assignmentPolicyOptions,
} from '@edulastic/constants'
import {
  call,
  put,
  all,
  takeEvery,
  takeLatest,
  select,
  take,
} from 'redux-saga/effects'
import { push, replace, goBack } from 'connected-react-router'
import _, {
  keyBy as _keyBy,
  omit,
  get,
  uniqBy,
  uniq as _uniq,
  isEmpty,
  identity,
  differenceBy,
  round,
  pick,
  isUndefined,
  findLastIndex,
  cloneDeep,
} from 'lodash'
import {
  testsApi,
  assignmentApi,
  contentSharingApi,
  tagsApi,
  passageApi,
  testItemsApi,
  analyticsApi,
  settingsApi,
  getVQUsageCountApi,
  segmentApi,
} from '@edulastic/api'
import moment from 'moment'
import nanoid from 'nanoid'
import produce from 'immer'
import * as Sentry from '@sentry/browser'

import {
  captureSentryException,
  helpers,
  notification,
  Effects,
} from '@edulastic/common'
import signUpState from '@edulastic/constants/const/signUpState'
import {
  DISTRICT_ADMIN,
  SCHOOL_ADMIN,
} from '@edulastic/constants/const/roleType'
import { TEST_TYPE_SURVEY } from '@edulastic/constants/const/testTypes'

import {
  SHOW_TEXT_TO_SPEECH,
  STACKED_TRANSLATION,
  VQ_QUOTA_EXHAUSTED,
} from '@edulastic/constants/const/test'
import { LANGUAGE_EN } from '@edulastic/constants/const/languages'
import {
  storeClassStudentAssignmentMetadata,
  getFromLocalStorage,
} from '@edulastic/api/src/utils/Storage'
import { getDefaultAssignmentDueDateForRole } from '../AssignTest/utils/assignmentDateDefaults'
import {
  DEFAULT_TEST_TITLE,
  createGroupSummary,
  getSettingsToSaveOnTestType,
  applyRubricScoreToTest,
  showRubricToStudentsSetting,
  removeTestTTSFromTestSettings,
} from './utils'
import { aiGeneratedNeedsReview } from './aiReviewUtils'
import {
  SET_MAX_ATTEMPT,
  UPDATE_TEST_IMAGE,
  SET_SAFE_BROWSE_PASSWORD,
  ADD_ITEM_EVALUATION,
  CHANGE_PREVIEW,
  APPROVE_OR_REJECT_MULTIPLE_ITEM_SUCCESS,
  TOGGLE_REGRADE_MODAL,
} from '../src/constants/actions'
import {
  submitAIContentFeedbackRequestAction,
  submitAIContentFeedbackSuccessAction,
  submitAIContentFeedbackErrorAction,
} from '../AIFeatures/ducks/aiContentFeedback'
import {
  loadQuestionsAction,
  getQuestionsArraySelector,
  UPDATE_QUESTION,
  ADD_QUESTION,
  getTestFlowSubjectsSelector,
  getTestFlowGradesSelector,
} from '../sharedDucks/questions'
import { evaluateItem } from '../src/utils/evalution'
import createShowAnswerData from '../src/utils/showAnswer'
import {
  getItemsSubjectAndGradeAction,
  setTestItemsAction,
} from './components/AddItems/ducks'
import {
  getUserRole,
  getUserIdSelector,
  getUserId,
  getIsCurator,
  getUserSignupStatusSelector,
  getUserOrgId,
  currentDistrictInstitutionIds,
  getOrgGroupList,
  vqQuotaForDistrictSelector,
  getSchoolsByUserRoleSelector,
  isUserDistrictSuperAdminSelector,
  getTestTypesFormatedConstant,
  getUserTestTypes,
} from '../src/selectors/user'
import { receivePerformanceBandSuccessAction } from '../PerformanceBand/ducks'
import { receiveStandardsProficiencySuccessAction } from '../StandardsProficiency/ducks'
import {
  updateItemDocBasedSaga,
  togglePublishWarningModalAction,
  PROCEED_PUBLISH_ACTION,
  hasStandards,
} from '../ItemDetail/ducks'
import { saveUserWorkAction } from '../../assessment/actions/userWork'
import { isFeatureAccessible } from '../../features/components/FeaturesSwitch'
import { getDefaultSettings } from '../../common/utils/helpers'
import {
  updateAssingnmentSettingsAction,
  UPDATE_ASSIGNMENT_SETTINGS_STATE,
} from '../AssignTest/duck'
import { SET_ITEM_SCORE } from '../src/ItemScore/ducks'
import {
  getIsloadingAssignmentSelector,
  getSelecedCoursesSelector,
  setAutoAssignRuleAction,
} from './components/Assign/ducks'
import { sortTestItemQuestions } from '../dataUtils'
import { answersByQId } from '../../assessment/selectors/test'
import { multiFind } from '../../common/utils/main'
import {
  hasValidResponse,
  isContentVisibilityRestrictedForCurrentUser,
} from '../questionUtils'
import { getProfileKey } from '../../common/utils/testTypeUtils'
import selectsData from './components/common/selectsData'
import { itemFields } from '../AssessmentCreate/components/CreateAITest/ducks/constants'
import { setUserFeaturesAction } from '../../student/Login/ducks'
import { getSearchParams } from '../src/utils/util'
import { validateTestForExpiredItems } from '../utils/tests'
import {
  getAdvancedSearchCoursesSelector,
  getAdvancedSearchSchoolsSelector,
  getAdvancedSearchTagsSelector,
  getIsAdvancedSearchSelectedSelector,
} from '../AdvanceSearch/ducks'
import { stackedTranslationMap } from '../../assessment/components/Common/StackedTranslator/constants'
import { getModifiedTestItemWithGroupPassageId } from './components/Review/components/helper'
import { changeDataToPreferredLanguage } from '../../assessment/utils/question'

import { PREVIEW } from '../../assessment/constants/constantsForQuestions'

const { allGrades, allSubjects } = selectsData

const {
  ITEM_GROUP_TYPES,
  ITEM_GROUP_DELIVERY_TYPES,
  completionTypes,
  releaseGradeLabels,
  evalTypeLabels,
  passwordPolicy,
  testCategoryTypes,
  SHOW_IMMERSIVE_READER,
  SHOW_SPEECH_TO_TEXT,
} = testConstants
const testItemStatusConstants = {
  INREVIEW: 'inreview',
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
}
const { WIDGET_TYPES } = questionType

export const MAX_ITEMS_DELIVER_COUNT = 100

export const NewGroup = {
  type: ITEM_GROUP_TYPES.STATIC /* Default : static */,
  groupName: 'SECTION 1' /* For now, auto-generated. */,
  items: [],
  deliveryType: ITEM_GROUP_DELIVERY_TYPES.ALL,
  index: 0,
}
export const NewGroupAutoselect = {
  type: ITEM_GROUP_TYPES.AUTOSELECT /* Default : static */,
  groupName: 'SECTION 1' /* For now, auto-generated. */,
  items: [],
  deliveryType: ITEM_GROUP_DELIVERY_TYPES.ALL_RANDOM,
  index: 0,
  difficulty: selectsData.allAuthorDifficulty[0].value,
}
export const createWidget = ({ id, type, title }) => ({
  widgetType: type === 'sectionLabel' ? 'resource' : 'question',
  type,
  title,
  reference: id,
  tabIndex: 0,
})

export const createNewStaticGroup = () => ({
  ...NewGroup,
  _id: nanoid(),
})

export const getStaticGroupItemIds = (_test) =>
  (
    _test.itemGroups.flatMap((itemGroup = {}) => {
      if (itemGroup.type === ITEM_GROUP_TYPES.STATIC) {
        return itemGroup?.items.map((item) => item._id) || []
      }
      return []
    }) || []
  ).filter((e) => !!e)

export const getAllItemIdsFromTest = (itemGroups) => {
  const itemIds = itemGroups.flatMap(({ items }) => {
    return items.map((item) => item._id)
  })
  return itemIds.filter((item) => !!item)
}

const transformItemGroupsUIToMongo = (itemGroups, scoring = {}) =>
  produce(itemGroups, (_itemGroups) => {
    for (const itemGroup of _itemGroups) {
      if (
        itemGroup.type === ITEM_GROUP_TYPES.STATIC ||
        (itemGroup.type === ITEM_GROUP_TYPES.AUTOSELECT &&
          itemGroup.items?.length)
      ) {
        delete itemGroup.pickCount
        const isLimitedDeliveryType =
          itemGroup.deliveryType === ITEM_GROUP_DELIVERY_TYPES.LIMITED_RANDOM

        if (isLimitedDeliveryType && !itemGroup.itemsDefaultMaxScore) {
          itemGroup.itemsDefaultMaxScore = 1
        }
        // For delivery type:LIMITED scoring should be as how item level scoring works
        itemGroup.items = itemGroup.items.map((o) => ({
          itemId: o._id,
          maxScore: isLimitedDeliveryType
            ? itemGroup.itemsDefaultMaxScore || 1
            : scoring[o._id] || helpers.getPoints(o),
          questions: o.data
            ? helpers.getQuestionLevelScore(
                {
                  ...o,
                  isLimitedDeliveryType,
                  itemsDefaultMaxScore: itemGroup.itemsDefaultMaxScore,
                },
                o.data.questions,
                helpers.getPoints(o),
                scoring[o._id]
              )
            : {},
        }))
      } else itemGroup.items = []
    }
  })

export const getTestGradeAndSubject = (
  group,
  testGrades,
  testSubjects,
  testTags
) => {
  if (group.type === ITEM_GROUP_TYPES.AUTOSELECT) {
    const gradesFromGroup = group?.standardDetails?.grades || []
    const subjectsFromGroup = group?.standardDetails?.subject
      ? [group.standardDetails.subject]
      : []
    const tagsFromGroup = group?.tags || []
    return {
      testGrades: _uniq([...testGrades, ...gradesFromGroup]),
      testSubjects: _uniq([...testSubjects, ...subjectsFromGroup]),
      testTags: _uniq([...testTags, ...tagsFromGroup]),
    }
  }
  return { testGrades, testSubjects, testTags: [] }
}

export const isRegradedByCoAuthor = (userId, entity, requestedTestId) => {
  if (
    entity.authors.some((item) => item._id === userId) &&
    entity._id !== requestedTestId &&
    entity.previousTestId === requestedTestId &&
    entity.status === 'published' &&
    entity.isUsed
  ) {
    return true
  }
  return false
}

export const SET_ASSIGNMENT = '[assignments] set assignment' // TODO remove cyclic dependency
export const CREATE_TEST_REQUEST = '[tests] create test request'
export const CREATE_TEST_SUCCESS = '[tests] create test success'
export const CREATE_TEST_ERROR = '[tests] create test error'

export const UPDATE_TEST_REQUEST = '[tests] update test request'
export const UPDATE_TEST_DOC_BASED_REQUEST =
  '[tests] update doc based test request'
export const UPDATE_TEST_SUCCESS = '[tests] update test success'
export const UPDATE_TEST_ERROR = '[tests] update test error'

export const RECEIVE_TEST_BY_ID_REQUEST = '[tests] receive test by id request'
export const RECEIVE_TEST_BY_ID_SUCCESS = '[tests] receive test by id success'
export const SET_FREEZE_TEST_SETTINGS =
  '[tests] set freeze test settings from test'
export const REMOVE_TEST_ENTITY = '[tests] remove entity'
export const RECEIVE_TEST_BY_ID_ERROR = '[tests] receive test by id error'

export const SET_TEST_DATA = '[tests] set test data'
export const SET_DEFAULT_TEST_DATA = '[tests] set default test data'
export const SET_TEST_EDIT_ASSIGNED = '[tests] set edit assigned'
export const REGRADE_TEST = '[regrade] set regrade data'
export const TEST_SHARE = '[test] send test share request'
export const TEST_PUBLISH = '[test] publish test'
export const UPDATE_TEST_STATUS = '[test] update test status'
export const CLEAR_TEST_DATA = '[test] clear test data'
export const CLEAR_CART_TEST_DATA = '[test] clear cart test data'
export const TEST_CREATE_SUCCESS = '[test] create test succes'
export const SET_REGRADE_OLD_TESTID = '[test] set regrade old test_id'
export const UPDATE_ENTITY_DATA = '[test] update entity data'
export const RECEIVE_SHARED_USERS_LIST = '[test] receive shared users list'
export const UPDATE_SHARED_USERS_LIST = '[test] update shared with users list'
export const DELETE_SHARED_USER = '[test] delete share user from list'
export const SET_TEST_DATA_AND_SAVE = '[test] set test data and update test'
export const SET_CREATED_ITEM_TO_TEST = '[test] set created item to test'
export const CLEAR_CREATED_ITEMS_FROM_TEST =
  '[test] clear createdItems from test'
export const PREVIEW_CHECK_ANSWER = '[test] check answer for preview modal'
export const PREVIEW_SHOW_ANSWER = '[test] show answer for preview modal'
export const REPLACE_TEST_DATA = '[test] replace test data'
export const UPDATE_TEST_DEFAULT_IMAGE = '[test] update default thumbnail image'
export const SET_PASSAGE_ITEMS = '[tests] set passage items'
export const SET_AND_SAVE_PASSAGE_ITEMS = '[tests] set and save passage items'
export const GET_ALL_TAGS_IN_DISTRICT = '[test] get all tags in district'
export const SEARCH_TAG_LIST_REQUEST = '[test] search tags request'
export const SEARCH_TAG_LIST_SUCCESS = '[test] search tags success'
export const SEARCH_TAG_LIST_ERROR = '[test] search tags error'
export const SEARCH_TAGS_BY_IDS_REQUEST = '[test] search tags by id request'
export const APPEND_KNOWN_TAGS = '[test] append known tags'
export const SET_ALL_TAGS = '[test] set all tags'
export const SET_ALL_TAGS_FAILED = '[test] set all tags failure'
export const ADD_NEW_TAG = '[test] add new tag'
export const RECEIVE_DEFAULT_TEST_SETTINGS =
  '[tests] receive default test settings'
export const SET_DEFAULT_TEST_TYPE_PROFILES =
  '[tests] set default test type profiles'
export const PUBLISH_FOR_REGRADE = '[tests] publish test for regrade'
export const DELETE_ANNOTATION = '[tests] delete annotations from test'
export const SET_LOADING_TEST_PAGE = '[tests] set loading'
export const DUPLICATE_TEST_REQUEST = '[tests] duplicate request'
export const UPDATE_TEST_AND_NAVIGATE = '[tests] update test and navigate'
export const APPROVE_OR_REJECT_SINGLE_TEST_REQUEST =
  '[test page] approve or reject single test request'
export const APPROVE_OR_REJECT_SINGLE_TEST_SUCCESS =
  '[test page] approve or reject single test success'
export const UPDATE_GROUP_DATA = '[tests] update group data'
export const ADD_NEW_GROUP = '[tests] add new group'
export const SET_CURRENT_GROUP_INDEX = '[tests] set current group index'
export const DELETE_ITEMS_GROUP = '[tests] delete items group'
export const DELETE_ITEM_GROUP_BY_GROUP_INDEX =
  '[tests] delete item group by group index'
export const ADD_ITEMS_TO_AUTOSELECT_GROUPS_REQUEST =
  '[test] add items to autoselect groups request'
export const ADD_ITEMS_TO_AUTOSELECT_GROUP =
  '[test] add items to autoselect group'
export const SET_TEST_PASSAGE_AFTER_CREATE =
  '[test] set passage after passage create'
export const UPDATE_LAST_USED_COLLECTION_LIST =
  '[test] update recent collections'
export const UPDATE_CREATING = '[test] create test request initiated'
export const SET_DEFAULT_SETTINGS_LOADING = '[test] deafult settings loading'
export const SET_AUTOSELECT_ITEMS_FETCHING_STATUS =
  '[test] set autoselect items fetching status'
export const SET_REGRADING_STATE = '[test] set regrading state'
export const SET_EDIT_ENABLE = '[test] set enable edit state'
export const SET_CURRENT_ANNOTATION_TOOL = '[SnapQuiz] annotation tools'
export const UPDATE_ANNOTATION_TOOLS_PROPERTIES =
  '[SnapQuiz] update annotation tools properties'
export const SET_ANNOTATIONS_STACK =
  '[SnapQuiz] reset undo stack and redo stack'
export const UNDO_ANNOTATONS_OPERATION = '[SnapQuiz] UNDO annotations operation'
export const REDO_ANNOTATONS_OPERATION = '[SnapQuiz] REDO annotations operation'
export const TOGGLE_TEST_LIKE = '[test] toggle test like'
export const UPDATE_TEST_LIKE_COUNT = '[test] update test like count'
export const UPDATE_TEST_ITEM_LIKE_COUNT =
  '[test] update test review item like count'
export const RESET_UPDATED_TEST_STATE = '[test] reset test updated state'
export const SET_UPDATING_TEST_FOR_REGRADE_STATE =
  '[test] set updating test for regrade state'
export const GET_TESTID_FROM_VERSIONID = '[test] get testId from versionId'
export const SET_REGRADE_FIRESTORE_DOC_ID = '[test] set regrade firestore docId'
export const SET_CORRECT_PSSAGE_ITEMS_CREATED =
  '[test] set correct passage items data in created items'
export const SET_SHARING_CONTENT_STATE = '[test] set sharing content state'
export const UPDATE_EMAIL_NOTIFICATION_DATA =
  '[test] update email notification data'
export const GET_REGRADE_ACTIONS = '[tests] get available regrade actions'
export const SET_REGRADE_ACTIONS = '[tests] set available regrade actions'
export const SET_DEFAULT_TEST_SETTINGS = '[tests] set default test settings'
export const SAVE_TEST_SETTINGS = '[tests] save test settings'
export const SET_CURRENT_TEST_SETTINGS_ID =
  '[tests] set current test settings id action'
export const FETCH_TEST_SETTINGS_LIST = '[tests] fetch test settings list'
export const SET_TEST_SETTINGS_LIST = '[tests] set test settings list'
export const UPDATE_TEST_SETTING_IN_LIST = '[tests] update test setting in list'
export const ADD_TEST_SETTING_IN_LIST = '[tests] add test setting in list'
export const REMOVE_TEST_SETTING_FROM_LIST =
  '[tests] remove test setting from list'
export const DELETE_TEST_SETTING_REQUEST = '[tests] delete test setting request'
export const UPDATE_TEST_SETTING_REQUEST = '[tests] update test setting request'
export const SET_SHOW_REGRADE_CONFIRM =
  '[tests] set show regrade confirmation popup'
export const SET_SHOW_UPGRADE_POPUP = '[tests] set show upgrade popup'
export const SET_MAX_SHARING_LEVEL_ALLOWED =
  '[tests] set max sharing level allowed'
export const TOGGLE_PENALTY_ON_USING_HINTS =
  '[tests] toggle penalty on using hints'
export const SET_VQ_ENABLE_YOUTUBE_ED = '[tests] set VQ enable YoutubeED'
export const SET_ENABLE_AUDIO_RESONSE_QUESTION =
  '[tests] set enable audio response question'
export const GET_YOUTUBE_THUMBNAIL_REQUEST =
  '[test] get youtube thumbnail request'
export const GET_YOUTUBE_THUMBNAIL_SUCCESS =
  '[test] get youtube thumbnail success'
export const SET_YOUTUBE_THUMBNAIL_FAILURE =
  '[test] set youtube thumbnail failure'
export const SET_ALLOW_SA_DISTRICT_COMMON_SETTING =
  '[tests] set allow school admin district common setting'
export const SET_ALLOW_TEACHER_COMMON_TEST_SETTING =
  '[tests] set allow teacher common test setting'
export const SET_AUTO_SCROLL_REVIEW_PAGE =
  '[tests] set auto scroll for review page to create item button'
export const SET_QUESTION_TYPE_CHANGED_TESTITEM_ID =
  '[tests] set question type changed testitem id'
export const REPLACE_RESTRICTED_ITEM = '[tests] replace restricted item'
export const SET_ITEM_PREVIEW_MODAL_VISIBILITY =
  '[tests] item preview modal visibility'
export const SET_REPLACE_ITEM_ID = '[tests] replace item id'
export const SET_REPLACE_ITEMS = '[tests] replace items'
export const DERIVE_AND_SAVE_AUTO_ASSIGN_RULE =
  '[tests] derive and save auto assign rule'
export const UPDATE_CART_ITEM_DETAIL = '[tests] update cart item detail'
export const UPDATE_QUESTION_CLARIFIERS = '[tests] update question clarifiers'
export const SET_IS_ASSIGN_SETTINGS_LOADED =
  '[tests] set is assign settings loaded'
export const REVIEW_AI_GENERATED_REQUEST =
  '[tests] ai generated reviewed request'
export const REVIEW_AI_GENERATED_SUCCESS =
  '[tests] ai generated reviewed success'
export const MARK_TEST_AS_REVIEWED_REQUEST =
  '[tests] mark test as reviewed request'
export const MARK_TEST_AS_REVIEWED_SUCCESS =
  '[tests] mark test as reviewed success'
export const MARK_TEST_AS_REVIEWED_FAILURE =
  '[tests] mark test as reviewed failure'
export const SUBMIT_AI_TEST_FEEDBACK_REQUEST =
  '[tests] submit ai test feedback request'

// actions

export const previewCheckAnswerAction = createAction(PREVIEW_CHECK_ANSWER)
export const previewShowAnswerAction = createAction(PREVIEW_SHOW_ANSWER)
export const replaceTestDataAction = createAction(REPLACE_TEST_DATA)
export const updateDefaultThumbnailAction = createAction(
  UPDATE_TEST_DEFAULT_IMAGE
)
export const togglePenaltyOnUsingHintsAction = createAction(
  TOGGLE_PENALTY_ON_USING_HINTS
)
export const setEnableAudioResponseQuestionAction = createAction(
  SET_ENABLE_AUDIO_RESONSE_QUESTION
)
export const setPassageItemsAction = createAction(SET_PASSAGE_ITEMS)
export const setAndSavePassageItemsAction = createAction(
  SET_AND_SAVE_PASSAGE_ITEMS
)
export const getAllTagsAction = createAction(GET_ALL_TAGS_IN_DISTRICT)
export const searchTagsAction = createAction(SEARCH_TAG_LIST_REQUEST)
export const searchTagsByIdsAction = createAction(SEARCH_TAGS_BY_IDS_REQUEST)
export const setAllTagsAction = createAction(SET_ALL_TAGS)
export const getDefaultTestSettingsAction = createAction(
  RECEIVE_DEFAULT_TEST_SETTINGS
)
export const publishForRegradeAction = createAction(PUBLISH_FOR_REGRADE)
export const setTestsLoadingAction = createAction(SET_LOADING_TEST_PAGE)
export const duplicateTestRequestAction = createAction(DUPLICATE_TEST_REQUEST)
export const updateTestAndNavigateAction = createAction(
  UPDATE_TEST_AND_NAVIGATE
)
export const removeTestEntityAction = createAction(REMOVE_TEST_ENTITY)
export const approveOrRejectSingleTestRequestAction = createAction(
  APPROVE_OR_REJECT_SINGLE_TEST_REQUEST
)
export const approveOrRejectSingleTestSuccessAction = createAction(
  APPROVE_OR_REJECT_SINGLE_TEST_SUCCESS
)
export const updateGroupDataAction = createAction(UPDATE_GROUP_DATA)
export const addNewGroupAction = createAction(ADD_NEW_GROUP)
export const setCurrentGroupIndexAction = createAction(SET_CURRENT_GROUP_INDEX)
export const deleteItemsGroupAction = createAction(DELETE_ITEMS_GROUP)
export const deleteItemGroupByGroupIndexAction = createAction(
  DELETE_ITEM_GROUP_BY_GROUP_INDEX
)
export const addItemsToAutoselectGroupsRequestAction = createAction(
  ADD_ITEMS_TO_AUTOSELECT_GROUPS_REQUEST
)
export const addItemsToAutoselectGroupAction = createAction(
  ADD_ITEMS_TO_AUTOSELECT_GROUP
)
export const setTestPassageAction = createAction(SET_TEST_PASSAGE_AFTER_CREATE)
export const updateTestEntityAction = createAction(SET_TEST_DATA)
export const updateLastUsedCollectionListAction = createAction(
  UPDATE_LAST_USED_COLLECTION_LIST
)
export const setIsCreatingAction = createAction(UPDATE_CREATING)
export const setDefaultSettingsLoadingAction = createAction(
  SET_DEFAULT_SETTINGS_LOADING
)
export const setAutoselectItemsFetchingStatusAction = createAction(
  SET_AUTOSELECT_ITEMS_FETCHING_STATUS
)
export const setRegradingStateAction = createAction(SET_REGRADING_STATE)
export const setRegradeFirestoreDocId = createAction(
  SET_REGRADE_FIRESTORE_DOC_ID
)
export const setEditEnableAction = createAction(SET_EDIT_ENABLE)
export const setCurrentAnnotationToolAction = createAction(
  SET_CURRENT_ANNOTATION_TOOL
)
export const updateAnnotationToolsPropertiesAction = createAction(
  UPDATE_ANNOTATION_TOOLS_PROPERTIES
)
export const undoAnnotationsAction = createAction(UNDO_ANNOTATONS_OPERATION)
export const redoAnnotationsAction = createAction(REDO_ANNOTATONS_OPERATION)
export const toggleTestLikeAction = createAction(TOGGLE_TEST_LIKE)
export const updateTestLikeCountAction = createAction(UPDATE_TEST_LIKE_COUNT)
export const updateTestItemLikeCountAction = createAction(
  UPDATE_TEST_ITEM_LIKE_COUNT
)
export const resetUpdatedStateAction = createAction(RESET_UPDATED_TEST_STATE)
export const setUpdatingTestForRegradeStateAction = createAction(
  SET_UPDATING_TEST_FOR_REGRADE_STATE
)
export const getTestIdFromVersionIdAction = createAction(
  GET_TESTID_FROM_VERSIONID
)
export const setSharingContentStateAction = createAction(
  SET_SHARING_CONTENT_STATE
)
export const updateEmailNotificationDataAction = createAction(
  UPDATE_EMAIL_NOTIFICATION_DATA
)
export const setShowRegradeConfirmPopupAction = createAction(
  SET_SHOW_REGRADE_CONFIRM
)
export const setShowUpgradePopupAction = createAction(SET_SHOW_UPGRADE_POPUP)

export const setAvailableRegradeAction = createAction(SET_REGRADE_ACTIONS)
export const getYoutubeThumbnailAction = createAction(
  GET_YOUTUBE_THUMBNAIL_REQUEST
)
export const setYoutubeThumbnailAction = createAction(
  GET_YOUTUBE_THUMBNAIL_SUCCESS
)

export const setYoutubeThumbnailFailure = createAction(
  SET_YOUTUBE_THUMBNAIL_FAILURE
)
export const setCanSchoolAdminUseDistrictCommonAction = createAction(
  SET_ALLOW_SA_DISTRICT_COMMON_SETTING
)
export const setCanTeacherAuthorCommonTestAction = createAction(
  SET_ALLOW_TEACHER_COMMON_TEST_SETTING
)
export const setQuestionTypeChangedTestItemIdAction = createAction(
  SET_QUESTION_TYPE_CHANGED_TESTITEM_ID
)

export const setModalVisibilityAction = createAction(
  SET_ITEM_PREVIEW_MODAL_VISIBILITY
)

export const setReplaceItemIdAction = createAction(SET_REPLACE_ITEM_ID)
export const setReplaceItemsAction = createAction(SET_REPLACE_ITEMS)

export const replaceRestrictedItemAction = createAction(REPLACE_RESTRICTED_ITEM)

export const deriveAndSaveAutoAssignRuleAction = createAction(
  DERIVE_AND_SAVE_AUTO_ASSIGN_RULE
)

export const setIsAssignSettingsLoadedAction = createAction(
  SET_IS_ASSIGN_SETTINGS_LOADED
)

export const reviewAiGeneratedRequestAction = createAction(
  REVIEW_AI_GENERATED_REQUEST
)
export const reviewAiGeneratedSuccessAction = createAction(
  REVIEW_AI_GENERATED_SUCCESS
)
export const markTestAsReviewedRequestAction = createAction(
  MARK_TEST_AS_REVIEWED_REQUEST
)
export const markTestAsReviewedSuccessAction = createAction(
  MARK_TEST_AS_REVIEWED_SUCCESS
)
export const markTestAsReviewedFailureAction = createAction(
  MARK_TEST_AS_REVIEWED_FAILURE
)
export const submitAITestFeedbackAction = createAction(
  SUBMIT_AI_TEST_FEEDBACK_REQUEST
)

export const receiveTestByIdAction = (
  id,
  requestLatest,
  editAssigned,
  isPlaylist = false,
  playlistId = undefined,
  options = {}
) => ({
  type: RECEIVE_TEST_BY_ID_REQUEST,
  payload: {
    id,
    requestLatest,
    editAssigned,
    isPlaylist,
    playlistId,
    options: {
      assigningNew: false,
      from: null,
      ...options,
    },
  },
})

export const receiveTestByIdSuccess = (entity) => ({
  type: RECEIVE_TEST_BY_ID_SUCCESS,
  payload: { entity },
})

export const setFreezeTestSettings = (freezeSettings) => ({
  type: SET_FREEZE_TEST_SETTINGS,
  payload: { freezeSettings },
})

export const receiveTestByIdError = (error) => ({
  type: RECEIVE_TEST_BY_ID_ERROR,
  payload: { error },
})

/**
 * To create a new test from the data passed.
 * @param {object} data
 * @param {boolean} toReview
 * @param {boolean} isCartTest
 */
export const createTestAction = (
  data,
  toReview = false,
  isCartTest = false
) => ({
  type: CREATE_TEST_REQUEST,
  payload: { data, toReview, isCartTest },
})

export const createTestSuccessAction = (entity) => ({
  type: CREATE_TEST_SUCCESS,
  payload: { entity },
})

export const createTestErrorAction = (error) => ({
  type: CREATE_TEST_ERROR,
  payload: { error },
})

export const updateTestAction = (id, data, updateLocal) => ({
  type: UPDATE_TEST_REQUEST,
  payload: { id, data, updateLocal },
})

export const updateDocBasedTestAction = (id, data, updateLocal) => ({
  type: UPDATE_TEST_DOC_BASED_REQUEST,
  payload: { id, data, updateLocal },
})

export const updateTestSuccessAction = (entity) => ({
  type: UPDATE_TEST_SUCCESS,
  payload: { entity },
})

export const updateTestErrorAction = (error) => ({
  type: UPDATE_TEST_ERROR,
  payload: { error },
})

export const setTestDataAction = ({ cart, ...data }) => ({
  type: SET_TEST_DATA,
  payload: { data, cart },
})

export const setTestDataAndUpdateAction = (data) => ({
  type: SET_TEST_DATA_AND_SAVE,
  payload: data,
})
export const clearTestDataAction = () => ({
  type: CLEAR_TEST_DATA,
})

export const clearCartTestDataAction = () => ({
  type: CLEAR_CART_TEST_DATA,
})

export const setDefaultTestDataAction = () => ({
  type: SET_DEFAULT_TEST_DATA,
})

export const setCreateSuccessAction = () => ({
  type: TEST_CREATE_SUCCESS,
})

export const setTestEditAssignedAction = createAction(SET_TEST_EDIT_ASSIGNED)
export const regradeTestAction = (payload) => ({
  type: REGRADE_TEST,
  payload,
})

export const sendTestShareAction = createAction(TEST_SHARE)
export const publishTestAction = createAction(TEST_PUBLISH)
export const updateTestStatusAction = createAction(UPDATE_TEST_STATUS)
export const setRegradeOldIdAction = createAction(SET_REGRADE_OLD_TESTID)
export const updateSharedWithListAction = createAction(UPDATE_SHARED_USERS_LIST)
export const setMaxSharingLevelAllowedAction = createAction(
  SET_MAX_SHARING_LEVEL_ALLOWED
)
export const receiveSharedWithListAction = createAction(
  RECEIVE_SHARED_USERS_LIST
)
export const deleteSharedUserAction = createAction(DELETE_SHARED_USER)
export const setCreatedItemToTestAction = createAction(SET_CREATED_ITEM_TO_TEST)
export const clearCreatedItemsAction = createAction(
  CLEAR_CREATED_ITEMS_FROM_TEST
)
export const addNewTagAction = createAction(ADD_NEW_TAG)
export const setDefaultTestTypeProfilesAction = createAction(
  SET_DEFAULT_TEST_TYPE_PROFILES
)
export const deleteAnnotationAction = createAction(DELETE_ANNOTATION)
export const setUndoStackAction = createAction(SET_ANNOTATIONS_STACK)
export const setCorrectPassageItemsCreatedAction = createAction(
  SET_CORRECT_PSSAGE_ITEMS_CREATED
)
export const getRegradeSettingsAction = createAction(GET_REGRADE_ACTIONS)

export const setDefaultTestSettingsAction = createAction(
  SET_DEFAULT_TEST_SETTINGS
)
export const saveTestSettingsAction = createAction(SAVE_TEST_SETTINGS)
export const setCurrentTestSettingsIdAction = createAction(
  SET_CURRENT_TEST_SETTINGS_ID
)
export const fetchTestSettingsListAction = createAction(
  FETCH_TEST_SETTINGS_LIST
)
export const setTestSettingsListAction = createAction(SET_TEST_SETTINGS_LIST)
export const updateTestSettingInList = createAction(UPDATE_TEST_SETTING_IN_LIST)
export const addTestSettingInList = createAction(ADD_TEST_SETTING_IN_LIST)
export const removeTestSettingFromList = createAction(
  REMOVE_TEST_SETTING_FROM_LIST
)
export const deleteTestSettingRequestAction = createAction(
  DELETE_TEST_SETTING_REQUEST
)
export const updateTestSettingRequestAction = createAction(
  UPDATE_TEST_SETTING_REQUEST
)
export const toggleRegradeModalAction = createAction(TOGGLE_REGRADE_MODAL)

export const setScrollToBottomAction = createAction(SET_AUTO_SCROLL_REVIEW_PAGE)

export const updateQuestionClarifiersAction = (payload) => ({
  type: UPDATE_QUESTION_CLARIFIERS,
  payload,
})

export const defaultImage =
  'https://cdn2.edulastic.com/default/default-test-1.jpg'

// selectors

export const stateSelector = (state) => state.tests

export const playlistStateSelector = (state) => state.playlist

export const isTestLoadingSelector = createSelector(
  stateSelector,
  (state) => state.creating || state.loading
)

export const canSchoolAdminUseDistrictCommonSelector = createSelector(
  stateSelector,
  (state) => state.canSchoolAdminUseDistrictCommon
)

export const canTeacherAuthorCommonTestsSelector = createSelector(
  stateSelector,
  (state) => state.canTeacherAuthorCommonTests
)

export const getPenaltyOnUsingHintsSelector = createSelector(
  stateSelector,
  (state) => state.hasPenaltyOnUsingHints
)

export const getPassageItemsCountSelector = createSelector(
  stateSelector,
  (state) => state.passageItems.length
)

export const getPassageItemsSelector = createSelector(
  stateSelector,
  (state) => state.passageItems
)

export const getRegradeFirebaseDocIdSelector = createSelector(
  stateSelector,
  (state) => state.regradeFirestoreDocId
)

export const getTestSelector = createSelector(
  stateSelector,
  (state) => state.entity
)

export const getTestQuestionsSelector = createSelector(
  getTestSelector,
  (test) => {
    const questions = []
    test?.itemGroups?.forEach((itemGroup) => {
      itemGroup?.items?.forEach((item) => {
        item?.data?.questions?.forEach((question) => {
          questions.push(question)
        })
      })
    })

    return questions
  }
)

export const getCartTestSelector = createSelector(
  stateSelector,
  (state) => state.cartTest
)

export const getPlaylistSelector = createSelector(
  playlistStateSelector,
  (state) => state.entity
)

export const defaultTestTypeProfilesSelector = createSelector(
  stateSelector,
  (state) => state.defaultTestTypeProfiles || {}
)

export const getDefaultThumbnailSelector = createSelector(
  stateSelector,
  (state) => state.thumbnail
)

export const getYoutubeThumbnailSelector = createSelector(
  stateSelector,
  (state) => state.ytThumbnail
)

export const getlastUsedCollectionListSelector = createSelector(
  stateSelector,
  (state) => state.lastUsedCollectionList || []
)

export const getTestEntitySelector = createSelector(
  stateSelector,
  (state) => state.entity
)

export const getTestEntitySubjectsSelector = createSelector(
  getTestEntitySelector,
  (state) => state?.subjects || []
)

export const getTestEntityGradesSelector = createSelector(
  getTestEntitySelector,
  (state) => state?.grades || []
)

// Resolves the test's subjects/grades wherever they are needed: prefer the live test
// entity (available on the test page), else fall back to the values carried across
// navigation in location.state (the entity is cleared once inside item authoring).
export const getResolvedTestSubjectsSelector = createSelector(
  getTestEntitySubjectsSelector,
  getTestFlowSubjectsSelector,
  (entitySubjects, locationStateSubjects) =>
    entitySubjects?.length ? entitySubjects : locationStateSubjects
)

export const getResolvedTestGradesSelector = createSelector(
  getTestEntityGradesSelector,
  getTestFlowGradesSelector,
  (entityGrades, locationStateGrades) =>
    entityGrades?.length ? entityGrades : locationStateGrades
)

export const getCollectionNameSelector = createSelector(
  getTestEntitySelector,
  (state) => state.collectionName
)

export const getCalcTypesSelector = createSelector(
  getTestEntitySelector,
  (entity) => entity.calcTypes
)

export const isDefaultTestSelector = createSelector(
  getTestEntitySelector,
  (test) => test?.testCategory === testCategoryTypes.DEFAULT
)

export const isVideoQuizSelector = createSelector(
  getTestEntitySelector,
  (test) => test?.testCategory === testCategoryTypes.VIDEO_BASED
)

export const isTestTypeWithDefaultTestTitleSelector = createSelector(
  getTestEntitySelector,
  (test) => {
    const {
      VIDEO_BASED,
      DEFAULT,
      DOC_BASED,
      DYNAMIC_TEST,
      ADAPTIVE_SECTION_TEST,
    } = testCategoryTypes
    return [
      VIDEO_BASED,
      DEFAULT,
      DOC_BASED,
      DYNAMIC_TEST,
      ADAPTIVE_SECTION_TEST,
    ].includes(test?.testCategory)
  }
)

export const isDynamicTestSelector = createSelector(
  getTestEntitySelector,
  (test) => test?.testCategory === testCategoryTypes.DYNAMIC_TEST
)

export const isAIDocExtractedSelector = createSelector(
  getTestEntitySelector,
  (test) => test?.aiDocExtracted || false
)

export const isTestReviewRequiredSelector = createSelector(
  getTestEntitySelector,
  (test) => test?.isReviewRequired || false
)

export const isTestOrItemReviewRequiredSelector = createSelector(
  getTestEntitySelector,
  (test) =>
    test?.isReviewRequired || aiGeneratedNeedsReview(test?.itemGroups || [])
)

export const markingTestAsReviewedSelector = createSelector(
  stateSelector,
  (state) => state?.markingTestAsReviewed || false
)

export const isSurveyTestSelector = createSelector(
  getTestEntitySelector,
  (test) => test?.testType === TEST_TYPE_SURVEY
)

export const hasSectionsSelector = createSelector(
  getTestEntitySelector,
  (test) => !!test?.hasSections
)

export const isCartTestHasSectionsSelector = createSelector(
  getCartTestSelector,
  (test) => !!test?.hasSections
)

export const isCartTestDynamicSelector = createSelector(
  getCartTestSelector,
  (test) => test?.testCategory === testCategoryTypes.DYNAMIC_TEST
)

export const sectionsEnabledDistrictSelector = createSelector(
  getUserOrgId,
  (districtId) => {
    const sectionsEnabledDistricts = process.env.REACT_APP_SECTIONS_ENABLED_DISTRICTS?.split(
      ','
    )
    return sectionsEnabledDistricts?.includes(districtId)
  }
)

// currently present testItems in the test.
export const getSelectedTestItemsSelector = createSelector(
  getTestEntitySelector,
  (_test) =>
    _test.itemGroups.flatMap((itemGroup) => itemGroup.items || []) || []
)

export const getCartTestItemsSelector = createSelector(
  getCartTestSelector,
  (_test) =>
    _test.itemGroups.flatMap((itemGroup) => itemGroup.items || []) || []
)

export const getItemGroupsSelector = createSelector(
  getTestEntitySelector,
  (_test) => _test.itemGroups || []
)

export const getTestItemsSelector = createSelector(
  getTestEntitySelector,
  (_test) => {
    const itemGroups = _test.itemGroups || []
    let testItems =
      itemGroups.flatMap((itemGroup) => {
        const isLimitedDeliveryType =
          itemGroup.deliveryType === ITEM_GROUP_DELIVERY_TYPES.LIMITED_RANDOM
        const itemExtras = {
          groupId: itemGroup._id,
          isLimitedDeliveryType,
        }
        if (isLimitedDeliveryType) {
          itemExtras.itemsDefaultMaxScore = itemGroup.itemsDefaultMaxScore
        }
        return (
          itemGroup.items.map((item) =>
            getModifiedTestItemWithGroupPassageId(
              { ...item, ...itemExtras },
              itemGroup
            )
          ) || []
        )
      }) || []
    testItems = sortTestItemQuestions(testItems)
    return testItems
  }
)

export const getDisableAnswerOnPaperSelector = createSelector(
  getTestEntitySelector,
  (_test) =>
    // disable answer on paper feature for deliveryType:LIMITED_RANDOM or group.type:AUTOSELECT
    _test?.itemGroups?.some(
      (group) =>
        group.deliveryType === ITEM_GROUP_DELIVERY_TYPES.LIMITED_RANDOM ||
        group.type === ITEM_GROUP_TYPES.AUTOSELECT
    )
)

export const getCurentTestPassagesSelector = createSelector(
  getTestEntitySelector,
  (_test) => _test.passages || []
)

export const getCartTestPassagesSelector = createSelector(
  getCartTestSelector,
  (_test) => _test.passages || []
)

export const getTestDefaultSettingsSelector = createSelector(
  stateSelector,
  (state) => state.defaultTestSettings
)

export const getTestSettingsListSelector = createSelector(
  stateSelector,
  (state) => state.savedTestSettingsList || []
)

export const getTestStatusSelector = createSelector(
  getTestEntitySelector,
  (state) => state.status
)

export const getTestIdSelector = createSelector(
  stateSelector,
  (state) => state.entity && state.entity._id
)

export const getContentSharingStateSelector = createSelector(
  stateSelector,
  (state) => state.isSharingContent
)

export const getShouldSendEmailStateSelector = createSelector(
  stateSelector,
  (state) => state.sendEmailNotification
)

export const getShowMessageBodyStateSelector = createSelector(
  stateSelector,
  (state) => state.showMessageBody
)

export const getEmailNotificationMessageSelector = createSelector(
  stateSelector,
  (state) => state.notificationMessage
)

export const getTestsCreatingSelector = createSelector(
  stateSelector,
  (state) => state.creating
)

export const getTestsUpdatedSelector = createSelector(
  stateSelector,
  (state) => state.updated
)

export const getTestsLoadingSelector = createSelector(
  stateSelector,
  (state) => state.loading
)

/**
 * On the test assign page, many actions are dispatched to update the assignment settings.
 * This selector is used to check if the assignment settings are fully loaded and perform
 * any other actions that need to be performed after the assignment settings are fully loaded.
 */
export const getIsAssignSettingsLoadedSelector = createSelector(
  stateSelector,
  (state) => state.isAssignSettingsLoaded
)

export const isYtLoadingSelector = createSelector(
  stateSelector,
  (state) => state.ytloading
)

export const getAutoSelectItemsLoadingStatusSelector = createSelector(
  stateSelector,
  (state) => state.isFetchingAutoselectItems
)

export const getDefaultSettingsLoadingSelector = createSelector(
  stateSelector,
  (state) => state.isSettingsLoading
)

export const shouldDisableSelector = createSelector(
  getTestsLoadingSelector,
  getIsloadingAssignmentSelector,
  (testLoading, assignmentsLoading) => testLoading || assignmentsLoading
)

export const getRegradingSelector = createSelector(
  stateSelector,
  (state) => state.regrading
)

export const getRegradeModalStateSelector = createSelector(
  stateSelector,
  (state) => state.regradeModalState
)

export const getIsLoadRegradeSettingsSelector = createSelector(
  stateSelector,
  (state) => state.loadRegradeSettings
)

export const getAvaialbleRegradeSettingsSelector = createSelector(
  stateSelector,
  (state) => state.availableRegradeSettings
)

export const getShowRegradeConfirmPopupSelector = createSelector(
  stateSelector,
  (state) => state.showRegradeConfirmPopup
)

export const getShowUpgradePopupSelector = createSelector(
  stateSelector,
  (state) => state.upgrade
)

export const getIsAudioResponseQuestionEnabled = createSelector(
  stateSelector,
  getUserRole,
  (state, userRole) =>
    [
      state?.enableAudioResponseQuestion,
      userRole === roleuser.EDULASTIC_CURATOR,
    ].some((o) => !!o)
)

export const showGroupsPanelSelector = createSelector(
  getTestEntitySelector,
  hasSectionsSelector,
  ({ itemGroups }, hasSections) => {
    if (!itemGroups?.length) {
      return false
    }
    return (
      itemGroups[0].type === ITEM_GROUP_TYPES.AUTOSELECT ||
      itemGroups[0].deliveryType === ITEM_GROUP_DELIVERY_TYPES.LIMITED_RANDOM ||
      itemGroups.length > 1 ||
      hasSections
    )
  }
)

export const getUserListSelector = createSelector(
  stateSelector,
  getUserOrgId,
  currentDistrictInstitutionIds,
  (state, districtId, institutionIds) => {
    const usersList = state.sharedUsersList || []
    const flattenUsers = []

    usersList.forEach(
      ({
        permission,
        sharedType,
        sharedWith,
        sharedId,
        v1Id,
        v1LinkShareEnabled = 0,
      }) => {
        if (sharedType === 'INDIVIDUAL' || sharedType === 'SCHOOL') {
          sharedWith.forEach((user) => {
            if (
              sharedType === 'SCHOOL' &&
              !institutionIds?.includes(user._id)
            ) {
              return
            }
            flattenUsers.push({
              userName: user.name,
              email: user.email || '',
              _userId: user._id,
              sharedType,
              permission: permission || user.permission,
              sharedId,
            })
          })
        } else {
          const shareData = {
            userName: sharedType,
            sharedType,
            permission: permission || sharedWith?.[0]?.permission,
            sharedId,
            v1Id,
            v1LinkShareEnabled,
          }
          if (sharedType === 'DISTRICT') {
            if (districtId !== sharedWith?.[0]?._id) {
              return
            }
            Object.assign(shareData, {
              shareWithName: sharedWith?.[0]?.name,
            })
          }
          if (sharedType === 'LINK') {
            shareData.v1Id = v1Id
            shareData.v1LinkShareEnabled = v1LinkShareEnabled
            shareData.userName = 'Anyone with link'
          }
          flattenUsers.push(shareData)
        }
      }
    )
    return flattenUsers
  }
)

export const getTestItemsRowsSelector = createSelector(
  getTestSelector,
  (state) =>
    state.itemGroups
      ?.flatMap((itemGroup) => itemGroup.items || [])
      ?.map((item) => {
        if (!item || !item.rows) return []
        return item?.rows?.map((row) => ({
          ...row,
          widgets: row?.widgets?.map((widget) => {
            let referencePopulate = {
              data: null,
            }

            if (
              item.data &&
              item.data.questions &&
              item.data.questions.length
            ) {
              referencePopulate = item.data.questions.find(
                (q) => q._id === widget.reference
              )
            }

            if (
              !referencePopulate &&
              item.data &&
              item.data.resources &&
              item.data.resources.length
            ) {
              referencePopulate = item.data.resources.find(
                (r) => r._id === widget.reference
              )
            }

            return {
              ...widget,
              referencePopulate,
            }
          }),
        }))
      })
)

export const getQuestionTypesInTestSelector = createSelector(
  getTestItemsRowsSelector,
  (testItemsRows) => {
    const questionTypes = []
    testItemsRows.forEach((testItemRows = []) => {
      testItemRows.forEach(({ widgets = [] }) => {
        widgets.forEach(({ widgetType, type }) => {
          if (widgetType === WIDGET_TYPES.QUESTION) {
            questionTypes.push(type)
          }
        })
      })
    })
    return questionTypes
  }
)

export const getScrollToBottomSelector = createSelector(
  stateSelector,
  (state) => state.scrollToBottom
)

// reducer
export const createBlankTest = () => ({
  title: DEFAULT_TEST_TITLE,
  description: '',
  releaseScore: releaseGradeLabels.DONT_RELEASE,
  maxAttempts: 1,
  testType: testTypesConstants.TEST_TYPES_VALUES_MAP.ASSESSMENT,
  testCategory: testCategoryTypes.DEFAULT,
  markAsDone: completionTypes.AUTOMATICALLY,
  generateReport: true,
  safeBrowser: false,
  sebPassword: '',
  blockNavigationToAnsweredQuestions: false,
  shuffleQuestions: false,
  shuffleAnswers: false,
  calcTypes: [],
  answerOnPaper: false,
  assignmentPassword: '',
  passwordExpireIn: 15 * 60,
  passwordPolicy: passwordPolicy.REQUIRED_PASSWORD_POLICY_OFF,
  maxAnswerChecks: 0,
  scoringType: evalTypeLabels.PARTIAL_CREDIT,
  penalty: false,
  isDocBased: false,
  status: 'draft',
  thumbnail: defaultImage,
  itemGroups: [createNewStaticGroup()],
  createdBy: {
    _id: '',
    name: '',
  },
  tags: [],
  scoring: {
    total: 0,
    testItems: [],
  },
  standardsTag: {
    curriculum: '',
    standards: [],
  },
  grades: [],
  subjects: [],
  courses: [],
  collections: [],
  analytics: [
    {
      usage: 0,
      likes: 0,
    },
  ],
  passages: [],
  freezeSettings: false,
  multiLanguageEnabled: false,
  playerSkinType: 'edulastic',
  keypad: { type: 'item-level', value: 'item-level-keypad', updated: false },
  timedAssignment: false,
  allowedTime: 0,
  hasInstruction: false,
  instruction: '',
  blockSaveAndContinue: false,
  restrictNavigationOut: null,
  restrictNavigationOutAttemptsThreshold: 0,
  showMagnifier: true,
  enableScratchpad: true,
  enableUploadWork: false,
  enableSkipAlert: false,
  showHintsToStudents: true,
  penaltyOnUsingHints: 0,
  allowTeacherRedirect: true,
  showTtsForPassages: true,
  hasSections: undefined,
  [SHOW_IMMERSIVE_READER]: undefined,
  [SHOW_SPEECH_TO_TEXT]: undefined,
  [SHOW_TEXT_TO_SPEECH]: undefined,
  [STACKED_TRANSLATION]: stackedTranslationMap.DISABLED,
})

const initialState = {
  entity: createBlankTest(),
  // new state is added for retaining the cart state globally until user creates test
  // entity state is getting cleared in multiple places which is causing some issue
  cartTest: createBlankTest(),
  error: null,
  page: 1,
  limit: 20,
  count: 0,
  updated: false,
  loading: false,
  creating: false,
  isSettingsLoading: false,
  thumbnail: '',
  regradeTestId: '',
  createdItems: [],
  sharedUsersList: [],
  passageItems: [],
  lastUsedCollectionList: [],
  tagsList: { playlist: [], test: [], group: [], testitem: [] },
  defaultTestTypeProfiles: {},
  currentGroupIndex: 0,
  isFetchingAutoselectItems: false,
  regrading: false,
  editEnable: false,
  currentAnnotationTool: 'cursor',
  annotationToolsProperties: {},
  annotationsStack: [],
  updatingTestForRegrade: false,
  regradeFirestoreDocId: '',
  isSharingContent: false,
  sendEmailNotification: false,
  showMessageBody: false,
  notificationMessage: '',
  loadRegradeSettings: false,
  availableRegradeSettings: [`ADD`, `EDIT`, `REMOVE`, `SETTINGS`],
  defaultTestSettings: {},
  savedTestSettingsList: [],
  currentTestSettingsId: '',
  regradeModalState: null,
  showRegradeConfirmPopup: false,
  upgrade: false,
  loadingSharedUsers: false,
  allKnownTags: [],
  tagSearchData: {
    result: [],
    isLoading: true,
  },
  hasPenaltyOnUsingHints: false,
  canSchoolAdminUseDistrictCommon: true,
  canTeacherAuthorCommonTests: false,
  ytThumbnail: '',
  ytloading: false,
  scrollToBottom: false,
  questionTypeChangedTestItemId: '',
  itemPreviewModalVisible: false,
  replaceItemId: null,
  equivalentItems: [],
  isAssignSettingsLoaded: false,
  aiGeneratedReviewInProgress: {},
  markingTestAsReviewed: false,
}

const getDefaultScales = (state, payload) => {
  const {
    performanceBandProfiles,
    standardsProficiencyProfiles,
    defaultTestTypeProfiles,
    allTestTypesInternal,
  } = payload
  const testType = getProfileKey(state.entity.testType, allTestTypesInternal)
  const bandId =
    performanceBandProfiles.find(
      (item) => item._id === defaultTestTypeProfiles?.performanceBand[testType]
    ) || {}
  const standardId =
    standardsProficiencyProfiles.find(
      (item) =>
        item._id === defaultTestTypeProfiles?.standardProficiency[testType]
    ) || {}
  const performanceBand = isEmpty(state.entity.performanceBand)
    ? {
        name: bandId.name,
        _id: bandId._id,
      }
    : state.entity.performanceBand
  const standardGradingScale = isEmpty(state.entity.standardGradingScale)
    ? {
        name: standardId.name,
        _id: standardId._id,
      }
    : state.entity.standardGradingScale
  return {
    performanceBand,
    standardGradingScale,
  }
}

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_DEFAULT_TEST_DATA:
      return { ...state, entity: createBlankTest(), updated: false }
    case UPDATE_TEST_DEFAULT_IMAGE:
      return { ...state, thumbnail: payload }
    case UPDATE_LAST_USED_COLLECTION_LIST:
      return { ...state, lastUsedCollectionList: payload }
    case RECEIVE_TEST_BY_ID_REQUEST:
      return { ...state, loading: true, error: null }
    case SET_TEST_EDIT_ASSIGNED:
      return { ...state, editAssigned: true }
    case SET_REGRADE_OLD_TESTID:
      return { ...state, regradeTestId: payload }
    case RECEIVE_TEST_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        aiGeneratedReviewInProgress: {},
        entity: {
          ...payload.entity,
          settingId: payload.entity.settingId || '',
        },
        updated: state.createdItems.length > 0,
      }
    case SET_FREEZE_TEST_SETTINGS:
      return {
        ...state,
        entity: {
          ...state.entity,
          ...payload,
        },
      }
    case REMOVE_TEST_ENTITY:
      return {
        ...state,
        createdItems: [],
        entity: createBlankTest(),
      }
    case RECEIVE_TEST_BY_ID_ERROR:
      return { ...state, loading: false, error: payload.error }

    case DELETE_ANNOTATION: {
      const { entity = {} } = state
      const { annotations = [] } = entity
      const payloadIndex = annotations.find((o) => o.questionId === payload)
        ?.qIndex
      return {
        ...state,
        entity: {
          ...entity,
          annotations: annotations
            .filter((o) => o.questionId !== payload)
            .map((ann) => ({
              ...ann,
              qIndex: ann.qIndex > payloadIndex ? ann.qIndex - 1 : ann.qIndex,
            })),
        },
      }
    }
    case CREATE_TEST_REQUEST:
    case UPDATE_TEST_REQUEST:
    case UPDATE_TEST_DOC_BASED_REQUEST:
      return { ...state, creating: true, error: null }
    case CREATE_TEST_SUCCESS:
    case UPDATE_TEST_SUCCESS:
      return {
        ...state,
        entity: payload.entity,
        createdItems: [],
        error: null,
        updated: false,
        creating: false,
      }
    case UPDATE_ENTITY_DATA: {
      return {
        ...state,
        entity: payload.entity,
        error: null,
        updated: false,
      }
    }
    case CREATE_TEST_ERROR:
    case UPDATE_TEST_ERROR:
      return { ...state, creating: false, error: payload.error }
    case SET_TEST_DATA: {
      const { cart = false, data } = payload
      const { updated = true, ...payloadData } = data
      /** **********
       * The Entity object is utilized to store either a fetched test or a test being edited.
       * Since the entity is involved in assignment, review, and publishing processes,
       * it's necessary to clear or replace this data to maintain state integrity.
       * Introducing the new cartTest state allows us to preserve the cart contents
       * even during assignment, review, or publishing actions.
       * The cartTest state is specifically designed for managing test creation from the cart.
       ********* */
      if (cart) {
        const cartTest = { ...state.cartTest, ...payloadData }
        return {
          ...state,
          cartTest,
        }
      }
      let entity = { ...state.entity, ...payloadData }
      if (
        payload.data?.restrictNavigationOut ===
          'warn-and-report-after-n-alerts' &&
        typeof entity?.restrictNavigationOutAttemptsThreshold === 'undefined'
      ) {
        entity = {
          ...entity,
          restrictNavigationOutAttemptsThreshold: 5,
        }
      } else if (payload.data?.restrictNavigationOut === 'warn-and-report') {
        entity = {
          ...entity,
          restrictNavigationOutAttemptsThreshold: undefined,
        }
      }
      return {
        ...state,
        entity,
        updated,
      }
    }
    case UPDATE_TEST_IMAGE:
      return {
        ...state,
        entity: {
          ...state.entity,
          thumbnail: payload.fileUrl,
        },
        updated: true,
      }
    case SET_ALL_TAGS:
      return {
        ...state,
        tagsList: { ...state.tagsList, [payload.tagType]: payload.tags },
      }
    case SET_ALL_TAGS_FAILED:
      return {
        ...state,
        tagsList: {
          ...state.tagsList,
          [payload.tagType]: [],
        },
      }
    case SEARCH_TAG_LIST_REQUEST:
      return {
        ...state,
        tagSearchData: {
          result: [],
          isLoading: true,
        },
      }
    case SEARCH_TAG_LIST_SUCCESS:
      return {
        ...state,
        tagSearchData: {
          result: payload,
          isLoading: false,
        },
      }
    case SEARCH_TAG_LIST_ERROR:
      return {
        ...state,
        tagSearchData: {
          result: [],
          isLoading: false,
        },
      }
    case APPEND_KNOWN_TAGS:
      return {
        ...state,
        allKnownTags: uniqBy([...state.allKnownTags, ...payload], '_id'),
      }
    case ADD_NEW_TAG:
      return {
        ...state,
        tagsList: {
          ...state.tagsList,
          [payload.tagType]: [
            ...(state.tagsList[payload.tagType] || []),
            payload.tag,
          ],
        },
      }
    case SET_MAX_ATTEMPT:
      return {
        ...state,
        entity: {
          ...state.entity,
          maxAttempts: payload.data,
        },
        updated: true,
      }
    case SET_SAFE_BROWSE_PASSWORD:
      return {
        ...state,
        entity: {
          ...state.entity,
          sebPassword: payload.data,
        },
      }
    case UPDATE_TEST_STATUS:
      return {
        ...state,
        entity: {
          ...state.entity,
          status: payload,
        },
      }
    case CLEAR_TEST_DATA:
      return {
        ...state,
        entity: createBlankTest(),
        updated: false,
        createdItems: [],
        thumbnail: '',
        sharedUsersList: [],
        ytThumbnail: '',
        questionTypeChangedTestItemId: '',
      }
    case CLEAR_CART_TEST_DATA:
      return {
        ...state,
        cartTest: createBlankTest(),
        updated: false,
        createdItems: [],
      }
    case SET_CREATED_ITEM_TO_TEST:
      return {
        ...state,
        createdItems: [payload, ...state.createdItems],
        updated: true,
      }
    case TEST_CREATE_SUCCESS:
      return {
        ...state,
        updated: false,
        creating: false,
      }
    case UPDATE_SHARED_USERS_LIST:
      return {
        ...state,
        sharedUsersList: payload,
        loadingSharedUsers: false,
      }
    case CLEAR_CREATED_ITEMS_FROM_TEST:
      return {
        ...state,
        createdItems: [],
      }
    case REPLACE_TEST_DATA:
      return {
        ...state,
        entity: {
          ...payload,
        },
      }
    case SET_PASSAGE_ITEMS:
      return {
        ...state,
        passageItems: [...payload],
      }
    case SET_DEFAULT_TEST_TYPE_PROFILES:
      // eslint-disable-next-line no-case-declarations
      const {
        performanceBand = {},
        standardGradingScale = {},
      } = getDefaultScales(state, payload)
      return {
        ...state,
        defaultTestTypeProfiles: payload.defaultTestTypeProfiles,
        entity: {
          ...state.entity,
          performanceBand,
          standardGradingScale,
        },
        enableAudioResponseQuestion: payload.enableAudioResponseQuestion,
      }
    case SET_LOADING_TEST_PAGE:
      return { ...state, loading: payload }
    case ADD_QUESTION:
    case UPDATE_QUESTION:
      return produce(state, (_state) => {
        if (_state.entity.isDocBased) {
          const newSubjects =
            payload?.alignment
              ?.flatMap((x) => x.subject)
              ?.filter((x) => x && x?.trim()) || []
          const newGrades =
            payload?.alignment?.flatMap((x) => x.grades || []) || []
          _state.entity.grades = _uniq([..._state.entity.grades, ...newGrades])
          _state.entity.subjects = _uniq([
            ..._state.entity.subjects,
            ...newSubjects,
          ])
        }
      })
    case APPROVE_OR_REJECT_MULTIPLE_ITEM_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const itemIdsMap = _keyBy(payload.itemIds)

      return {
        ...state,
        entity: {
          ...state.entity,
          itemGroups: [
            {
              ...state.entity.itemGroups[0],
              items: state.entity.itemGroups[0].items.map((i) => {
                if (itemIdsMap[i._id]) {
                  return {
                    ...i,
                    status: payload.status,
                  }
                }
                return i
              }),
            },
          ],
        },
      }
    case APPROVE_OR_REJECT_SINGLE_TEST_SUCCESS:
      return {
        ...state,
        entity: {
          ...state.entity,
          status: payload.status,
          collections: payload.collection
            ? payload.collection
            : state.entity.collections,
        },
      }
    case UPDATE_GROUP_DATA:
      // eslint-disable-next-line no-case-declarations
      const { testGrades, testSubjects, testTags } = getTestGradeAndSubject(
        payload?.updatedGroupData,
        state.entity.grades,
        state.entity.subjects,
        state.entity.tags
      )
      return {
        ...state,
        updated: true,
        entity: {
          ...state.entity,
          itemGroups: state.entity.itemGroups.map((group, index) => {
            if (index === payload.groupIndex) return payload.updatedGroupData
            return group
          }),
          grades: testGrades,
          subjects: testSubjects,
          tags: testTags,
        },
      }
    case ADD_NEW_GROUP:
      return {
        ...state,
        entity: {
          ...state.entity,
          itemGroups: [...state.entity.itemGroups, payload],
        },
      }
    case SET_CURRENT_GROUP_INDEX:
      return {
        ...state,
        currentGroupIndex: payload,
      }
    case DELETE_ITEMS_GROUP:
      return {
        ...state,
        updated: true,
        entity: {
          ...state.entity,
          itemGroups: state.entity.itemGroups.filter(
            (g) => g.groupName !== payload
          ),
        },
      }
    case DELETE_ITEM_GROUP_BY_GROUP_INDEX:
      return {
        ...state,
        updated: true,
        entity: {
          ...state.entity,
          itemGroups: state.entity.itemGroups.filter(
            (itemGroup, index) => index !== payload
          ),
        },
      }
    case ADD_ITEMS_TO_AUTOSELECT_GROUP:
      return {
        ...state,
        entity: {
          ...state.entity,
          itemGroups: produce(state.entity.itemGroups, (itemGroups) => {
            for (const itemGroup of itemGroups) {
              if (itemGroup.groupName === payload.groupName) {
                itemGroup.items = payload.items
                break
              }
            }
          }),
        },
      }
    case SET_TEST_PASSAGE_AFTER_CREATE:
      return {
        ...state,
        entity: {
          ...state.entity,
          passages: [...(state.entity.passages || []), payload],
        },
      }
    case UPDATE_CREATING:
      return {
        ...state,
        creating: payload,
      }
    case SET_DEFAULT_SETTINGS_LOADING:
      return {
        ...state,
        isSettingsLoading: payload,
      }
    case SET_AUTOSELECT_ITEMS_FETCHING_STATUS:
      return {
        ...state,
        isFetchingAutoselectItems: payload,
      }
    case SET_REGRADING_STATE:
      return {
        ...state,
        regrading: payload,
      }
    case SET_EDIT_ENABLE:
      return {
        ...state,
        editEnable: payload,
      }

    case SET_CURRENT_ANNOTATION_TOOL:
      return {
        ...state,
        currentAnnotationTool: payload,
      }
    case UPDATE_ANNOTATION_TOOLS_PROPERTIES:
      return {
        ...state,
        annotationToolsProperties: produce(
          state.annotationToolsProperties,
          (propertiesByKey) => {
            if (propertiesByKey[payload.key]) {
              propertiesByKey[payload.key] = {
                ...propertiesByKey[payload.key],
                ...payload?.value,
              }
            } else {
              propertiesByKey[payload.key] = payload.value
            }
          }
        ),
      }
    case SET_ANNOTATIONS_STACK:
      return {
        ...state,
        annotationsStack: [],
      }
    case UNDO_ANNOTATONS_OPERATION:
      return produce(state, (draft) => {
        const annotation = draft.entity.annotations.pop()
        draft.annotationsStack.push(annotation)
      })
    case REDO_ANNOTATONS_OPERATION:
      return produce(state, (draft) => {
        const annotation = draft.annotationsStack.pop()
        draft.entity.annotations.push(annotation)
      })

    case UPDATE_TEST_LIKE_COUNT:
      return {
        ...state,
        entity: {
          ...state.entity,
          analytics: [
            {
              usage: state.entity?.analytics?.[0]?.usage,
              likes: payload.toggleValue
                ? (state.entity?.analytics?.[0]?.likes || 0) + 1
                : (state.entity?.analytics?.[0]?.likes || 1) - 1,
            },
          ],
          alreadyLiked: payload.toggleValue,
        },
      }
    case UPDATE_TEST_ITEM_LIKE_COUNT:
      return {
        ...state,
        entity: {
          ...state.entity,
          itemGroups: state.entity.itemGroups.map((itemGroup) => {
            const items = itemGroup.items.map((i) => {
              if (i.versionId === payload.versionId) {
                return {
                  ...i,
                  analytics: [
                    {
                      usage: i?.analytics?.[0]?.usage || 0,
                      likes: payload.toggleValue
                        ? (i?.analytics?.[0]?.likes || 0) + 1
                        : (i?.analytics?.[0]?.likes || 1) - 1,
                    },
                  ],
                  alreadyLiked: payload.toggleValue,
                }
              }
              return i
            })
            return {
              ...itemGroup,
              items,
            }
          }),
        },
      }
    case RESET_UPDATED_TEST_STATE:
      return {
        ...state,
        updated: false,
      }
    case SET_UPDATING_TEST_FOR_REGRADE_STATE:
      return {
        ...state,
        updatingTestForRegrade: payload,
      }
    case SET_REGRADE_FIRESTORE_DOC_ID:
      return {
        ...state,
        regradeFirestoreDocId: payload,
      }
    case SET_CORRECT_PSSAGE_ITEMS_CREATED:
      return {
        ...state,
        createdItems: state.createdItems.map(
          (i) => payload.find((it) => it._id === i._id) || i
        ),
      }
    case SET_SHARING_CONTENT_STATE:
      return {
        ...state,
        isSharingContent: payload,
      }
    case UPDATE_EMAIL_NOTIFICATION_DATA:
      return {
        ...state,
        ...payload,
      }
    case GET_REGRADE_ACTIONS:
      return {
        ...state,
        loadRegradeSettings: true,
      }
    case SET_REGRADE_ACTIONS:
      return {
        ...state,
        availableRegradeSettings: payload,
        loadRegradeSettings: false,
      }
    case SET_DEFAULT_TEST_SETTINGS:
      return {
        ...state,
        defaultTestSettings: payload,
      }
    case SET_CURRENT_TEST_SETTINGS_ID:
      return {
        ...state,
        currentTestSettingsId: payload,
      }
    case SET_ALLOW_SA_DISTRICT_COMMON_SETTING:
      return {
        ...state,
        canSchoolAdminUseDistrictCommon: payload,
      }
    case SET_ALLOW_TEACHER_COMMON_TEST_SETTING:
      return {
        ...state,
        canTeacherAuthorCommonTests: payload,
      }
    case SET_TEST_SETTINGS_LIST:
      return {
        ...state,
        savedTestSettingsList: payload,
      }
    case ADD_TEST_SETTING_IN_LIST:
      return {
        ...state,
        savedTestSettingsList: [...state.savedTestSettingsList, payload],
      }
    case REMOVE_TEST_SETTING_FROM_LIST:
      return {
        ...state,
        savedTestSettingsList: state.savedTestSettingsList.filter(
          (t) => t._id !== payload
        ),
      }
    case UPDATE_TEST_SETTING_IN_LIST:
      return {
        ...state,
        savedTestSettingsList: state.savedTestSettingsList.map((t) => {
          if (payload._id === t._id) return payload
          return t
        }),
      }
    case TOGGLE_REGRADE_MODAL:
      return {
        ...state,
        regradeModalState: payload,
      }
    case SET_SHOW_REGRADE_CONFIRM:
      return {
        ...state,
        showRegradeConfirmPopup: payload,
      }
    case SET_SHOW_UPGRADE_POPUP:
      return {
        ...state,
        upgrade: payload,
      }
    case RECEIVE_SHARED_USERS_LIST:
      return {
        ...state,
        loadingSharedUsers: true,
      }
    case SET_MAX_SHARING_LEVEL_ALLOWED:
      return {
        ...state,
        maxSharingLevelAllowed: payload,
      }
    case TOGGLE_PENALTY_ON_USING_HINTS:
      return {
        ...state,
        updated: true,
        hasPenaltyOnUsingHints: payload,
      }
    case SET_ENABLE_AUDIO_RESONSE_QUESTION:
      return {
        ...state,
        enableAudioResponseQuestion: payload,
      }
    case GET_YOUTUBE_THUMBNAIL_REQUEST:
      return {
        ...state,
        ytloading: true,
      }
    case GET_YOUTUBE_THUMBNAIL_SUCCESS:
      return {
        ...state,
        ytThumbnail: payload,
        ytloading: false,
      }
    case SET_YOUTUBE_THUMBNAIL_FAILURE:
      return {
        ...state,
        ytloading: false,
      }
    case SET_AUTO_SCROLL_REVIEW_PAGE:
      return {
        ...state,
        scrollToBottom: payload,
      }
    case SET_QUESTION_TYPE_CHANGED_TESTITEM_ID:
      return {
        ...state,
        questionTypeChangedTestItemId: payload,
      }
    case REPLACE_RESTRICTED_ITEM:
      return {
        ...state,
        replaceItemId: payload,
      }
    case SET_ITEM_PREVIEW_MODAL_VISIBILITY: {
      return {
        ...state,
        itemPreviewModalVisible: payload,
      }
    }
    case SET_REPLACE_ITEM_ID: {
      return {
        ...state,
        replaceItemId: payload,
      }
    }
    case SET_REPLACE_ITEMS: {
      return {
        ...state,
        equivalentItems: payload,
      }
    }
    case UPDATE_CART_ITEM_DETAIL: {
      const { cartTest } = state
      if (cartTest?.itemGroups) {
        const { item } = payload
        const newItemGroups = cartTest.itemGroups.map((ig) => ({
          ...ig,
          items: ig.items?.map((cartItem) =>
            cartItem._id === item._id ? { ...cartItem, ...item } : cartItem
          ),
        }))

        return {
          ...state,
          cartTest: {
            ...cartTest,
            itemGroups: newItemGroups,
          },
        }
      }
      return state
    }
    case SET_IS_ASSIGN_SETTINGS_LOADED:
      return {
        ...state,
        isAssignSettingsLoaded: payload,
      }
    case REVIEW_AI_GENERATED_REQUEST:
      return produce(state, (draft) => {
        draft.aiGeneratedReviewInProgress[payload.itemId] = true
      })
    case REVIEW_AI_GENERATED_SUCCESS:
      return produce(state, (draft) => {
        delete draft.aiGeneratedReviewInProgress[payload.itemId]
        for (const group of draft.entity?.itemGroups || []) {
          const item = (group.items || []).find((i) => i._id === payload.itemId)
          if (item) {
            item.aiGeneratedAnswerReviewed = true
            break
          }
        }
      })
    case MARK_TEST_AS_REVIEWED_REQUEST:
      return produce(state, (draft) => {
        draft.markingTestAsReviewed = true
      })
    case MARK_TEST_AS_REVIEWED_FAILURE:
      return produce(state, (draft) => {
        draft.markingTestAsReviewed = false
      })
    case MARK_TEST_AS_REVIEWED_SUCCESS:
      return produce(state, (draft) => {
        draft.markingTestAsReviewed = false
        if (draft.entity) {
          draft.entity.isReviewRequired = false
          ;(draft.entity.itemGroups || []).forEach((group) => {
            ;(group.items || []).forEach((item) => {
              if (item.aiGeneratedAnswerReviewed === false) {
                item.aiGeneratedAnswerReviewed = true
              }
            })
          })
        }
      })
    default:
      return state
  }
}

/**
 * Return all question of a test.
 * @param {Object} itemGroups - list of item groups
 *  itemGroups will be array of groups having testItems in it.
 *
 */
export const getQuestions = (itemGroups = []) => {
  const allQuestions = []
  for (const itemGroup of itemGroups) {
    for (const item of itemGroup.items) {
      const { questions = [], resources = [] } = item.data || {}
      const questionsWithItemId = [...questions, ...resources].map((q) => ({
        ...q,
        testItemId: item._id,
      }))
      allQuestions.push(...questionsWithItemId)
    }
  }
  return allQuestions
}

// created user state here bcz of circular dependency.
// login ducks update test state for filters.
const userStateSelector = (state) => state.user

export const getUserFeatures = createSelector(
  userStateSelector,
  (state) => state.user.features
)

export const getReleaseScorePremiumSelector = createSelector(
  getTestSelector,
  getUserFeatures,
  (entity, features) => {
    const { subjects, grades } = entity
    return (
      features?.assessmentSuperPowersReleaseScorePremium ||
      (grades &&
        subjects &&
        isFeatureAccessible({
          features,
          inputFeatures: 'assessmentSuperPowersReleaseScorePremium',
          gradeSubject: { grades, subjects },
        }))
    )
  }
)

export const getCartTestReleaseScorePremiumSelector = createSelector(
  getCartTestSelector,
  getUserFeatures,
  (entity, features) => {
    const { subjects, grades } = entity
    return (
      features?.assessmentSuperPowersReleaseScorePremium ||
      (grades &&
        subjects &&
        isFeatureAccessible({
          features,
          inputFeatures: 'assessmentSuperPowersReleaseScorePremium',
          gradeSubject: { grades, subjects },
        }))
    )
  }
)

export const getIsOverrideFreezeSelector = createSelector(
  getTestSelector,
  getUserRole,
  (_test, role) => {
    const allowedRoles = [SCHOOL_ADMIN, DISTRICT_ADMIN]
    if (!_test.freezeSettings) {
      return false
    }
    if (allowedRoles.includes(role)) {
      return false
    }
    return true
  }
)
// get adaptiveDelivery for test
export const getAdaptiveDeliverySelector = createSelector(
  getTestSelector,
  (_test) =>
    !isEmpty(_test?.adaptiveDelivery) ? _test?.adaptiveDelivery : null
)
// To check adaptive Test for Assign/Test review page
export const isSectionAdaptiveTestSelector = createSelector(
  getTestSelector,
  (_test) => _test?.testCategory === testCategoryTypes.ADAPTIVE_SECTION_TEST
)

export const isNormalSectionsTestSelector = createSelector(
  hasSectionsSelector,
  isDynamicTestSelector,
  isSectionAdaptiveTestSelector,
  (hasSections, isDynamicTest, isAdaptiveTest) =>
    hasSections && !isDynamicTest && !isAdaptiveTest
)

export const enableSectionReOrderSelector = createSelector(
  getTestSelector,
  isSectionAdaptiveTestSelector,
  (_test, adaptiveTest) =>
    !_test?.isInEditAndRegrade && _test?.hasSections && !adaptiveTest
)

export const getAllTagsSelector = (state, tagType) => {
  const _state = stateSelector(state)
  return get(_state, ['tagsList', tagType], [])
}

export const getTagSearchSelector = createSelector(stateSelector, (state) =>
  get(state, 'tagSearchData', {})
)

export const getTagSearchListSelector = createSelector(
  getTagSearchSelector,
  (state) => get(state, 'result', [])
)

// tags which were searched for previously are cached as allKnownTags
// and used to display filter tags
export const getKnownTagsSelector = createSelector(stateSelector, (state) =>
  get(state, 'allKnownTags', [])
)

export const getCurrentGroupIndexSelector = createSelector(
  stateSelector,
  (state) => state.currentGroupIndex
)

export const getTestSummarySelector = createSelector(
  getTestEntitySelector,
  (state) => createGroupSummary(state)
)

export const getTestCreatedItemsSelector = createSelector(
  stateSelector,
  (state) => get(state, 'createdItems', [])
)

export const getCurrentSettingsIdSelector = createSelector(
  stateSelector,
  (state) => state.currentTestSettingsId
)

export const getQuestionTypeChangedTestItemIdSelector = createSelector(
  stateSelector,
  (state) => state?.questionTypeChangedTestItemId || ''
)

export const getIsItemPreviewModalVisibleSelector = createSelector(
  stateSelector,
  (state) => state?.itemPreviewModalVisible
)

export const getReplaceItemIdSelector = createSelector(
  stateSelector,
  (state) => state.replaceItemId
)

export const getEquivalentItemsSelector = createSelector(
  stateSelector,
  (state) => state.equivalentItems || []
)

const setTime = (userRole) => getDefaultAssignmentDueDateForRole(userRole)

const getAssignSettings = ({
  userRole,
  entity,
  features,
  isPlaylist,
  allTestTypesInternal,
}) => {
  const testType = entity?.testType
  const { PRACTICE, COMMON, SURVEY } = allTestTypesInternal
  const {
    ASSESSMENT,
    PRACTICE: _PRACTICE,
  } = testTypesConstants.TEST_TYPES_VALUES_MAP
  const isAdmin =
    userRole === roleuser.SCHOOL_ADMIN || userRole === roleuser.DISTRICT_ADMIN

  const {
    showHintsToStudents = true,
    penaltyOnUsingHints = 0,
    showTtsForPassages = true,
    allowTeacherRedirect = true,
  } = entity

  const settings = {
    startDate: moment(),
    class: [],
    endDate: setTime(userRole),
    passwordPolicy: entity.passwordPolicy,
    passwordExpireIn: entity.passwordExpireIn,
    assignmentPassword: entity.assignmentPassword,
    timedAssignment: entity.timedAssignment,
    restrictNavigationOut: entity.restrictNavigationOut || null,
    restrictNavigationOutAttemptsThreshold:
      entity.restrictNavigationOutAttemptsThreshold || 0,
    blockSaveAndContinue: entity.blockSaveAndContinue || false,
    scoringType: entity.scoringType,
    penalty: entity.penalty,
    blockNavigationToAnsweredQuestions:
      entity.blockNavigationToAnsweredQuestions || false,
    showMagnifier: isUndefined(entity.showMagnifier)
      ? true
      : entity.showMagnifier,
    enableScratchpad: isUndefined(entity.enableScratchpad)
      ? true
      : entity.enableScratchpad,
    enableUploadWork: isUndefined(entity.enableUploadWork)
      ? true
      : entity.enableUploadWork,
    enableSkipAlert: !!entity.enableSkipAlert,
    keypad: entity.keypad,
    testType: entity.testType,
    maxAttempts: entity.maxAttempts,
    markAsDone: entity.markAsDone,
    releaseScore: entity.releaseScore,
    safeBrowser: entity.safeBrowser,
    shuffleAnswers: entity.shuffleAnswers,
    shuffleQuestions: entity.shuffleQuestions,
    calcTypes: entity.calcTypes,
    answerOnPaper: entity.answerOnPaper,
    maxAnswerChecks: entity.maxAnswerChecks,
    showRubricToStudents: entity.showRubricToStudents,
    allowAutoEssayEvaluation: entity.allowAutoEssayEvaluation,
    showHintsToStudents,
    penaltyOnUsingHints,
    allowTeacherRedirect,
    showTtsForPassages,
    showImmersiveReader: entity.showImmersiveReader,
    showSpeechToText: entity.showSpeechToText,
    showTextToSpeech: entity.showTextToSpeech,
    vqPreventSkipping: entity.vqPreventSkipping,
    vqEnableClosedCaption: entity.vqEnableClosedCaption,
    stackedTranslation: entity.stackedTranslation,
    vqEnableSpeedControl: entity.vqEnableSpeedControl,
  }

  if (entity.safeBrowser) {
    settings.sebPassword = entity.sebPassword
  }

  if (isAdmin) {
    settings.testType = [...PRACTICE, ...SURVEY].includes(testType)
      ? testType
      : COMMON.includes(testType)
      ? testType
      : testTypesConstants.DEFAULT_ADMIN_TEST_TYPE_MAP[userRole]
    settings.openPolicy =
      assignmentPolicyOptions.POLICY_OPEN_MANUALLY_BY_TEACHER
  }

  if (!isAdmin) {
    settings.testType = testType || ASSESSMENT
    settings.openPolicy = assignmentPolicyOptions.POLICY_AUTO_ON_STARTDATE
    delete settings.allowTeacherRedirect
  }

  if (entity.timedAssignment) {
    settings.allowedTime = entity.allowedTime || 10 * 60 * 1000
    settings.pauseAllowed = entity.pauseAllowed || false
  }

  if (!isPlaylist && features.free && !features.premium) {
    settings.testType = PRACTICE.includes(testType) ? _PRACTICE : ASSESSMENT
    settings.maxAttempts = 1
    settings.markAsDone = completionTypes.AUTOMATICALLY
    settings.releaseScore = releaseGradeLabels.DONT_RELEASE
    settings.safeBrowser = false
    settings.shuffleAnswers = false
    settings.shuffleQuestions = false
    settings.calcTypes = []
    settings.answerOnPaper = false
    settings.maxAnswerChecks = 0
    settings.scoringType = evalTypeLabels.PARTIAL_CREDIT
    settings.penalty = false
    settings.passwordPolicy = passwordPolicy.REQUIRED_PASSWORD_POLICY_OFF
    settings.timedAssignment = false
    settings.blockNavigationToAnsweredQuestions = false
    settings.enableSkipAlert = false
    settings.enableUploadWork = false
    settings.blockSaveAndContinue = false
    settings.restrictNavigationOut = null
    settings.restrictNavigationOutAttemptsThreshold = 0
    settings.showRubricToStudents = false
    settings.allowAutoEssayEvaluation = false
    settings.showHintsToStudents = true
    settings.penaltyOnUsingHints = 0
    settings.showTtsForPassages = true
    settings.referenceDocAttributes = {}
    delete settings.keypad
  }

  return settings
}

function validateRestrictNavigationOut(data) {
  if (
    data?.restrictNavigationOut === 'warn-and-report-after-n-alerts' &&
    !data?.restrictNavigationOutAttemptsThreshold
  ) {
    notification({
      type: 'warning',
      msg: 'Please enter a valid input for Restrict Navigation Out of Test',
    })
    document
      .getElementById('restrict-navigation-out')
      ?.querySelector('.ant-input-number-input')
      ?.focus()
    return false
  }
  return true
}

const notifyTestSaveOrPublishSuccess = (messageKey) => {
  notification({ type: 'success', messageKey })
}

const createDummyItems = (itemCount, group = {}) => {
  const items = []
  for (let i = 0; i < itemCount; i++) {
    const item = {
      _id: `dummyItemId-${i}-${group._id}`,
      isDummyItem: true,
      autoselectedItem: true,
      active: 1,
      algoVariablesEnabled: false,
      autoGrade: true,
      canAddMultipleItems: false,
      collections: [
        {
          name: group?.collectionDetails?.name,
          type: group?.collectionDetails?.type,
          _id: group?.collectionDetails?._id,
        },
      ],
      columns: [],
      curriculums: [],
      premiumContentRestriction: true,
      data: {
        questions: [
          {
            alignment: [],
            grades: [],
            id: `dummyQuestionId-${i}-${group._id}`,
            subjects: [],
            title: '',
            type: 'multipleChoice',
            validation: {
              scoringType: 'exactMatch',
              validResponse: { score: 1, value: [], altResponses: [] },
            },
          },
        ],
        resources: [],
      },
      itemLevelScore: 1,
      itemLevelScoring: true,
      language: 'english',
      maxScore: 1,
      rows: [
        {
          content: '',
          dimension: '100%',
          flowLayout: false,
          tabs: [],
          widgets: [
            {
              reference: `dummyQuestionId-${i}-${group._id}`,
              tabIndex: 0,
              title: '',
              type: '',
              widgetType: 'question',
            },
          ],
        },
      ],
      sharedWith: [],
      standards: [],
      status: 'published',
      subjects: [],
    }
    items.push(item)
  }
  return items
}

/**
 *  Adding dummy items to autoselect groups if a group content is restricted due to subscription expiry
 */
export const fillAutoselectGoupsWithDummyItems = (testEntity) => {
  testEntity.itemGroups.forEach((group) => {
    if (
      group.premiumContentRestriction &&
      group.items.length < group.deliverItemsCount
    ) {
      group.items = [
        ...group.items,
        ...createDummyItems(
          group.deliverItemsCount - group.items.length,
          group
        ),
      ]
    }
  })
}

export function* deriveAndSaveAutoAssignRuleSaga({ payload }) {
  const {
    schools,
    schoolsToExclude,
    courses,
    grades,
    subjects,
    tags,
    classType,
  } = payload
  const classTypeToLabelMap = {
    class: 'Classes',
    custom: 'Student Groups',
  }
  const derivedAutoAssignRule = {}
  const isAdvancedSearchSelected = yield select(
    getIsAdvancedSearchSelectedSelector
  )
  if (isAdvancedSearchSelected) {
    const fetchedSchools = yield select(getAdvancedSearchSchoolsSelector)
    const fetchedCourseList = yield select(getAdvancedSearchCoursesSelector)
    const fetchedTagList = yield select(getAdvancedSearchTagsSelector)
    if (schools) {
      derivedAutoAssignRule.schools = fetchedSchools
        .filter((school) => schools.includes(school.value))
        .map((school) => school.label)
    }
    if (schoolsToExclude) {
      derivedAutoAssignRule.schoolsToExclude = fetchedSchools
        .filter((school) => schoolsToExclude.includes(school.value))
        .map((school) => school.label)
    }
    if (courses) {
      derivedAutoAssignRule.courses = _uniq(
        fetchedCourseList
          .filter((course) => courses.includes(course.value.split(',')[0]))
          .map((course) => course.label)
      )
    }
    if (tags) {
      derivedAutoAssignRule.tags = fetchedTagList
        .filter((tag) => tags.includes(tag.value))
        .map((tag) => tag.label)
    }
  } else {
    const fetchedSchools = yield select(getSchoolsByUserRoleSelector)
    const fetchedCourseList = yield select(getSelecedCoursesSelector)
    const fetchedTagList = yield select((state) =>
      getAllTagsSelector(state, 'group')
    )
    if (schools) {
      derivedAutoAssignRule.schools = fetchedSchools
        .filter((school) => schools.includes(school._id))
        .map((school) => school.name)
    }
    if (schoolsToExclude) {
      derivedAutoAssignRule.schoolsToExclude = fetchedSchools
        .filter((school) => schoolsToExclude.includes(school._id))
        .map((school) => school.name)
    }
    if (courses) {
      derivedAutoAssignRule.courses = _uniq(
        fetchedCourseList
          .filter((course) =>
            courses.some((courseIdInRule) =>
              course._id.includes(courseIdInRule)
            )
          )
          .map((course) => course.name)
      )
    }
    if (tags) {
      derivedAutoAssignRule.tags = fetchedTagList
        .filter((tag) => tags.includes(tag._id))
        .map((tag) => tag.tagName)
    }
  }
  if (grades) {
    derivedAutoAssignRule.grades = grades?.map(
      (grade) => allGrades?.find((data) => data?.value === grade)?.text
    )
  }
  if (subjects) {
    derivedAutoAssignRule.subjects = subjects?.map(
      (subject) => allSubjects?.find((data) => data?.value === subject)?.text
    )
  }
  if (classType) {
    derivedAutoAssignRule.classType = classTypeToLabelMap[classType]
  }
  yield put(setAutoAssignRuleAction(derivedAutoAssignRule))
}

// saga
export function* receiveTestByIdSaga({ payload }) {
  try {
    const prevTest = yield select(getTestSelector)
    let createdItems = yield select(getTestCreatedItemsSelector)
    const { rubricScoreMap = {}, ...entity } = yield call(
      testsApi.getById,
      payload.id,
      {
        data: true,
        requestLatest: payload.requestLatest,
        editAndRegrade: payload.editAssigned,
        ...(payload.playlistId ? { playlistId: payload.playlistId } : {}),
      }
    )
    applyRubricScoreToTest(entity, rubricScoreMap)
    const userId = yield select(getUserIdSelector)
    const questionTypeUpdatedTestItemId = yield select(
      getQuestionTypeChangedTestItemIdSelector
    )
    if (
      payload.editAssigned &&
      isRegradedByCoAuthor(userId, entity, payload.id)
    ) {
      const regradeAssignments = yield call(
        assignmentApi.fetchRegradeAssignments,
        payload.id
      )
      if (regradeAssignments?.length) {
        yield put(setShowUpgradePopupAction(true))
        yield put(receiveTestByIdSuccess(entity))
        return
      }
    }
    entity.passages = [
      ...entity.passages,
      ...differenceBy(prevTest.passages, entity.passages, '_id'),
    ]
    fillAutoselectGoupsWithDummyItems(entity)
    const currentGroupIndex = yield select(getCurrentGroupIndexSelector)
    if (entity._id !== payload.id && !payload?.isPlaylist) {
      yield put(
        push({
          pathname: `/author/tests/tab/review/id/${entity._id}`,
          state: {
            showCancelButton: payload.editAssigned,
            editAssigned: payload.editAssigned,
          },
          ...getSearchParams('testType'),
        })
      )
    }

    entity.itemGroups.forEach((itemGroup, groupIndex) => {
      itemGroup.items.forEach((item, itemIndex) => {
        const createdItem = createdItems?.find(
          ({ _id, previousTestItemId }) =>
            _id === item._id || previousTestItemId === item._id
        )
        if (!isEmpty(createdItem)) {
          // update standards with updated db data for testitems
          createdItem.data?.questions?.forEach((createdQuestion) => {
            const question = item?.data?.questions.find(
              ({ id }) => id === createdQuestion.id
            )
            if (!isEmpty(question)) {
              createdQuestion.alignment = [...(question.alignment || [])]
            }
          })
          entity.itemGroups[groupIndex].items[itemIndex] = createdItem
          createdItems = createdItems?.filter(
            ({ _id }) => _id !== createdItem._id
          )
        }
      })
    })
    if (createdItems.length) {
      if (questionTypeUpdatedTestItemId?.length && !isEmpty(createdItems[0])) {
        const newTestItem = createdItems[0]
        entity.itemGroups.forEach((itemGroup, groupIndex) => {
          itemGroup.items.forEach((item, itemIndex) => {
            if (item?._id === questionTypeUpdatedTestItemId) {
              entity.itemGroups[groupIndex].items[itemIndex] = newTestItem
            }
          })
        })
      } else {
        const createdItemskeyedById = _keyBy(createdItems, '_id')
        entity.itemGroups[currentGroupIndex].items = uniqBy(
          [...entity.itemGroups[currentGroupIndex]?.items, ...createdItems],
          (x) =>
            createdItemskeyedById[x._id] ? x.previousTestItemId || x._id : x._id
        )
      }
    }
    const features = yield select(getUserFeatures)

    const questions = getQuestions(entity.itemGroups)
    yield put(loadQuestionsAction(_keyBy(questions, 'id')))
    yield put(receiveTestByIdSuccess(entity))
    yield put(getDefaultTestSettingsAction(entity))
    yield take(SET_DEFAULT_SETTINGS_LOADING)
    yield take(SET_DEFAULT_SETTINGS_LOADING)
    if (!isEmpty(entity.freeFormNotes)) {
      yield put(
        saveUserWorkAction({
          [entity.itemGroups?.[0]?.items?.[0]?._id]: {
            scratchpad: entity.freeFormNotes || {},
          },
        })
      )
    }
    if (entity.thumbnail === defaultImage) {
      const thumbnail = yield call(testsApi.getDefaultImage, {
        subject: get(entity, 'subjects[0]', 'Other Subjects'),
        standard: get(entity, 'summary.standards[0].identifier', ''),
      })
      yield put(updateDefaultThumbnailAction(thumbnail))
    }

    const userRole = yield select(getUserRole)
    const allTestTypesInternal = yield select(getTestTypesFormatedConstant)
    const assignSettings = getAssignSettings({
      userRole,
      entity,
      isPlaylist: payload.isPlaylist,
      features,
      allTestTypesInternal,
    })
    const loadedGroups = yield select((state) => state.assignmentSettings.class)
    const userClassList = yield select(getOrgGroupList)
    const activeGroups = yield select((state) => state.authorGroups.groups)
    if (
      loadedGroups?.length &&
      (userClassList?.filter((x) => x?.active === 1)?.length === 1 ||
        activeGroups?.length === 1)
    ) {
      assignSettings.class = loadedGroups
    }
    yield put(updateAssingnmentSettingsAction(assignSettings))
    yield take(UPDATE_ASSIGNMENT_SETTINGS_STATE)
    let defaultTestSettings = yield select(
      ({ assignmentSettings }) => assignmentSettings
    )
    defaultTestSettings = omit(defaultTestSettings, [
      'startDate',
      'class',
      'endDate',
      'openPolicy',
      'closePolicy',
      'resources',
    ])
    defaultTestSettings = {
      ...defaultTestSettings,
      testContentVisibility: entity.testContentVisibility,
    }
    const state = yield select((s) => ({
      performanceBands: get(s, 'performanceBandReducer.profiles', []),
      standardsProficiencies: get(s, 'standardsProficiencyReducer.data', []),
      defaultTestTypeProfiles: get(s, 'tests.defaultTestTypeProfiles', {}),
    }))
    let assignmentSettings = yield select((s) => s.assignmentSettings)
    if (payload.options?.assigningNew) {
      const performanceBandId =
        state.defaultTestTypeProfiles.performanceBand?.[
          getProfileKey(entity.testType, allTestTypesInternal)
        ]
      const standardProficiencyId =
        state.defaultTestTypeProfiles.standardProficiency?.[
          getProfileKey(entity.testType, allTestTypesInternal)
        ]
      assignmentSettings = { ...assignmentSettings }
      assignmentSettings.performanceBand = pick(
        multiFind(
          state.performanceBands,
          [{ _id: entity.performanceBand._id }, { _id: performanceBandId }],
          entity.performanceBand
        ),
        ['_id', 'name']
      )
      assignmentSettings.standardGradingScale = pick(
        multiFind(
          state.standardsProficiencies,
          [
            { _id: entity.standardGradingScale._id },
            { _id: standardProficiencyId },
          ],
          entity.standardGradingScale
        ),
        ['_id', 'name']
      )
    }
    yield put(updateAssingnmentSettingsAction(assignmentSettings))
    yield take(UPDATE_ASSIGNMENT_SETTINGS_STATE)
    yield put(setIsAssignSettingsLoadedAction(true))
    yield put(setDefaultTestSettingsAction(defaultTestSettings))
    yield put(addItemsToAutoselectGroupsRequestAction(entity))
  } catch (err) {
    captureSentryException(err)
    console.log({ err })
    const errorMessage = 'Unable to retrieve test info.'
    if (err.status === 403) {
      yield put(resetUpdatedStateAction())
      if (payload.editAssigned) {
        yield put(goBack())
        notification({
          type: 'error',
          msg: 'You do not have the permission to clone/edit the test.',
          exact: true,
        })
      } else {
        yield put(push('/author/tests'))
        notification({
          type: 'error',
          messageKey: 'curriculumMakeApiErr',
          exact: true,
        })
      }
    } else {
      notification({ msg: errorMessage })
    }
    yield put(receiveTestByIdError(errorMessage))
  } finally {
    yield put(setQuestionTypeChangedTestItemIdAction(''))
  }
}

function* createTest(data) {
  const { title, passwordPolicy: _passwordPolicy } = data

  if (title !== undefined && !title.trim().length) {
    return notification({ messageKey: 'nameShouldNotEmpty' })
  }
  if (_passwordPolicy !== passwordPolicy.REQUIRED_PASSWORD_POLICY_STATIC) {
    delete data.assignmentPassword
  }

  if (_passwordPolicy !== passwordPolicy.REQUIRED_PASSWORD_POLICY_DYNAMIC) {
    delete data.passwordExpireIn
  }
  const omitedItems = [
    'assignments',
    'createdDate',
    'updatedDate',
    'passages', // not accepted by backend validator (testSchema)  EV-10685
    'isUsed',
    'currentTab', // not accepted by backend validator (testSchema) EV-10685,
    'summary',
    'alreadyLiked',
    'savePreselected',
    'authorsFromUserDistrict',
    'accessLevel',
    'adminCoAuthors',
  ]
  const allTestTypesInternal = yield select(getTestTypesFormatedConstant)
  const allTestTypesInternalList = _.flatten(
    Object.values(allTestTypesInternal)
  )
  if (
    !allTestTypesInternal.COMMON.includes(data.testType) &&
    allTestTypesInternalList.includes(data.testType)
  ) {
    data.freezeSettings = false
    data.allowTeacherRedirect = true
    data.testContentVisibility = 'ALWAYS'
  }
  const dataToSend = omit(data, omitedItems)
  // we are getting testItem ids only in payload from cart, but whole testItem Object from test library.
  dataToSend.itemGroups = transformItemGroupsUIToMongo(data.itemGroups)
  if (dataToSend.settingId === '') {
    dataToSend.settingId = null
  }
  dataToSend.grades = dataToSend.grades?.filter((el) => !!el) || []
  dataToSend.subjects = dataToSend.subjects?.filter((el) => !!el) || []
  const entity = yield call(testsApi.create, dataToSend)
  fillAutoselectGoupsWithDummyItems(data)

  yield put({
    type: UPDATE_ENTITY_DATA,
    payload: {
      entity: { ...entity, itemGroups: data.itemGroups },
    },
  })
  return entity
}

function* createTestSaga({ payload }) {
  try {
    if (!validateRestrictNavigationOut(payload.data)) {
      return
    }
    const { nextLocation, nextAction } = payload.data
    nextLocation && delete payload.data.nextLocation

    const testItems = get(payload, 'data.itemGroups[0].items', [])
    let aiGeneratedTestItems = testItems
      .filter(({ unsavedItem }) => unsavedItem)
      .map((item) => pick(item, itemFields))
    const newTestItems = payload.data.savePreselected
      ? testItems.filter(({ unsavedItem }) => !unsavedItem) || []
      : []
    if (!isEmpty(aiGeneratedTestItems)) {
      aiGeneratedTestItems = yield call(
        testItemsApi.addItems,
        aiGeneratedTestItems
      )
    }
    if (payload.data.savePreselected && newTestItems?.length) {
      yield put(clearCartTestDataAction())
    }
    const allTestItems = [...newTestItems, ...aiGeneratedTestItems]
    const entity = yield createTest(
      produce(payload.data, (draft) => {
        if ((allTestItems || []).length) {
          draft.itemGroups[0].items = allTestItems
          delete draft.itemGroups[0].pickCount
        }
      })
    )

    entity.itemGroups = payload.data.itemGroups.map((group) => {
      group.items = group.items.map((it) => {
        if (it.unsavedItem) delete it.unsavedItem
        return it
      })
      return group
    })

    const lcbCustomGeneratedContentMetadata = yield select(
      (state) =>
        state?.router?.location?.state?.lcbCustomGeneratedContentMetadata
    ) || {}

    storeClassStudentAssignmentMetadata({
      ...lcbCustomGeneratedContentMetadata,
      testId: entity._id,
    })

    yield put(createTestSuccessAction(entity))
    yield put(addItemsToAutoselectGroupsRequestAction(entity))
    if (!nextAction) {
      if (nextLocation) {
        yield put(replace(nextLocation))
      } else {
        const pathname = yield select((state) => state.router.location.pathname)
        const currentTabMatch = pathname?.match(
          /(?:\/author\/tests\/(?:create|tab)\/)([^/]+)/
        )
        // try to keep the user on the same tab after test creation
        // Go to `description` tab if user is not on Test Page already, e.g. coming from Item Library.
        const currentTab =
          currentTabMatch?.[1] ||
          (payload.toReview
            ? 'review'
            : entity.testCategory === testCategoryTypes.DEFAULT
            ? 'addItems'
            : 'description')
        yield put(replace(`/author/tests/tab/${currentTab}/id/${entity._id}`))
      }
    }
    if (entity.aiGenerated && !nextAction) {
      yield put(setIsCreatingAction(true))
      yield put(receiveTestByIdAction(entity._id, true, false))
      yield put(setIsCreatingAction(false))
    }
    if (nextAction) nextAction(entity)

    notification({ type: 'success', messageKey: 'testCreated' })
  } catch (err) {
    captureSentryException(err)
    console.log({ err })

    const errorMessage = err?.data?.message || 'Failed to create test!'
    notification({ msg: errorMessage })
    yield put(createTestErrorAction(errorMessage))
  }
}

function hasInvalidItem(testData) {
  return testData.itemGroups.find((x) => x.items.find((_item) => !_item.itemId))
}

const cleanTestItemGroups = (_test) => {
  _test.itemGroups.forEach((group) => {
    if (group.premiumContentRestriction) {
      group.items = []
    }
    delete group.premiumContentRestriction
    delete group.replaceableRestrictedContent
  })
}

/**
 * update the showRubricToStudents setting if it was set to true
 * and later items with rubric attached are removed from the test
 */
const updateTestSettings = (testItemGroups, testData) => {
  if (
    testItemGroups?.length &&
    !showRubricToStudentsSetting(testItemGroups) &&
    testData.showRubricToStudents
  ) {
    testData.showRubricToStudents = false
    testData.allowAutoEssayEvaluation = false
  }
}

export function* updateTestSaga({ payload }) {
  try {
    if (!validateRestrictNavigationOut(payload.data)) {
      yield put(setTestsLoadingAction(false))
      return
    }
    // dont set loading as true
    if (!payload.disableLoadingIndicator) yield put(setTestsLoadingAction(true))
    const { scoring = {}, currentTab, nextLocation, nextAction } = payload.data
    const testFieldsToOmit = [
      '_id',
      'updatedDate',
      'createdDate',
      'assignments',
      'authors',
      'createdBy',
      'passages',
      'isUsed',
      'scoring',
      'sharedType',
      'currentTab',
      'summary',
      'alreadyLiked',
      'active',
      'nextLocation',
      'authorsFromUserDistrict',
      'accessLevel',
      'adminCoAuthors',
      'nextAction',
    ]
    // remove createdDate and updatedDate
    const oldId = payload.data._id
    const allTestTypesInternal = yield select(getTestTypesFormatedConstant)
    const allTestTypesInternalList = _.flatten(
      Object.values(allTestTypesInternal)
    )
    if (
      !allTestTypesInternal.COMMON.includes(payload.data.testType) &&
      allTestTypesInternalList.includes(payload.data.testType)
    ) {
      payload.data.freezeSettings = false
      payload.data.allowTeacherRedirect = true
      payload.data.testContentVisibility = 'ALWAYS'
    }

    // Backend doesn't require PARTIAL_CREDIT_IGNORE_INCORRECT
    // Penalty true/false is set to determine the case
    if (
      payload.data.scoringType ===
      evalTypeLabels.PARTIAL_CREDIT_IGNORE_INCORRECT
    ) {
      payload.data.scoringType = evalTypeLabels.PARTIAL_CREDIT
    }

    const pageStructure = get(payload.data, 'pageStructure', []).map(
      (page) => ({
        ...page,
        _id: undefined,
      })
    )

    payload.data.pageStructure = pageStructure.length
      ? pageStructure
      : undefined
    if (
      payload.data.passwordPolicy !==
      passwordPolicy.REQUIRED_PASSWORD_POLICY_DYNAMIC
    ) {
      testFieldsToOmit.push('passwordExpireIn')
    }
    if (
      payload.data.passwordPolicy !==
      passwordPolicy.REQUIRED_PASSWORD_POLICY_STATIC
    ) {
      testFieldsToOmit.push('assignmentPassword')
    } else if (
      payload.data.passwordPolicy ===
        passwordPolicy.REQUIRED_PASSWORD_POLICY_STATIC &&
      (!payload.data.assignmentPassword ||
        payload.data.assignmentPassword.length < 6 ||
        payload.data.assignmentPassword.length > 25)
    ) {
      notification({ messageKey: 'enterValidPassword' })
      return yield put(setTestsLoadingAction(false))
    }

    const aiGeneratedTestItems = []
    let selectedGroupForAI = -1
    payload.data.itemGroups.forEach((itemGroup, index) => {
      itemGroup.items
        .filter(({ unsavedItem }) => unsavedItem)
        .forEach((item) => {
          selectedGroupForAI = index
          aiGeneratedTestItems.push(pick(item, itemFields))
        })
    })

    let newTestItems
    if (!isEmpty(aiGeneratedTestItems)) {
      newTestItems = yield call(testItemsApi.addItems, aiGeneratedTestItems)
    }

    if ((newTestItems || []).length) {
      for (let index = 0; index < payload.data.itemGroups?.length; index++) {
        payload.data.itemGroups[index].items = [
          ...payload.data.itemGroups[index].items,
          ...(index === selectedGroupForAI ? newTestItems : []),
        ].filter(({ unsavedItem }) => !unsavedItem)
      }
    }

    const testItemGroups = payload.data.itemGroups

    payload.data.itemGroups = transformItemGroupsUIToMongo(
      payload.data.itemGroups,
      scoring
    )

    const role = yield select(getUserRole)
    if (role === roleuser.EDULASTIC_CURATOR) {
      payload.data.performanceBand = pick(payload.data?.performanceBand, [
        '_id',
        'name',
      ])
      payload.data.standardGradingScale = pick(
        payload.data?.standardGradingScale,
        ['_id', 'name']
      )
    }

    const testData = omit(payload.data, testFieldsToOmit)
    cleanTestItemGroups(testData)

    updateTestSettings(testItemGroups, testData)
    if (hasInvalidItem(testData)) {
      console.warn('test data has invalid item', testData)
      Sentry.configureScope((scope) => {
        scope.setExtra('testData', testData)
        Sentry.captureException(new Error('testDataHasInvalidException'))
      })
      return
    }
    if (testData.settingId === '') {
      testData.settingId = null
    }
    testData.grades = testData.grades?.filter((el) => !!el) || []
    testData.subjects = testData.subjects?.filter((el) => !!el) || []
    if (testData.collections?.length) {
      testData.collections = testData.collections.filter((el) => !!el?._id)
    }
    const entity = yield call(testsApi.update, { ...payload, data: testData })
    if (isEmpty(entity)) {
      return
    }
    fillAutoselectGoupsWithDummyItems(entity)
    yield put(updateTestSuccessAction(entity))
    yield put(addItemsToAutoselectGroupsRequestAction(entity))
    const newId = entity._id
    const userRole = yield select(getUserRole)
    const isCurator = yield select(getIsCurator)
    if (!nextAction) {
      if (nextLocation) {
        const locationState = yield select(
          (state) => get(state, 'router.location.state'),
          {}
        )
        yield put(
          push({
            pathname: nextLocation,
            state: locationState,
          })
        )
      } else if (oldId !== newId && newId) {
        if (!payload.assignFlow) {
          let url = `/author/tests/${newId}/versioned/old/${oldId}`
          if (currentTab) {
            url = `/author/tests/tab/${currentTab}/id/${newId}/old/${oldId}`
          }
          const locationState = yield select(
            (state) => get(state, 'router.location.state'),
            {}
          )
          yield put(
            push({
              pathname: url,
              state: locationState,
            })
          )
        }
      } else if (!payload.assignFlow) {
        if (userRole === roleuser.EDULASTIC_CURATOR || isCurator)
          notifyTestSaveOrPublishSuccess('testSaved')
        else notifyTestSaveOrPublishSuccess('testSavedAsDraft')
      }
    }
    yield put(setTestsLoadingAction(false))
    if (nextAction && typeof nextAction === 'function') nextAction(entity)
    else if (nextAction && typeof nextAction === 'object') {
      yield put(nextAction)
    }
    return entity
  } catch (err) {
    captureSentryException(err, {
      errorMessage: 'failed to update test',
      saga: 'updateTestSaga',
      data: payload,
    })
    console.error(err)
    const errorMessage = err?.data?.message || 'Unable to update the test.'
    notification({ type: 'error', msg: errorMessage })
    yield put(updateTestErrorAction(errorMessage))
    yield put(setTestsLoadingAction(false))
    yield put(setUpdatingTestForRegradeStateAction(false))
  }
}

function* updateTestDocBasedSaga({ payload }) {
  try {
    if (!validateRestrictNavigationOut(payload.data)) {
      yield put(setUpdatingTestForRegradeStateAction(false))
      return
    }
    const _questions =
      payload?.data?.itemGroups?.[0]?.items?.[0]?.data?.questions || []
    const QuestionsbyId = {}
    // rely on versionId else fallback to questionId
    _questions.forEach((q) => {
      QuestionsbyId[q?.versionId || q.id] = q
    })
    const assessmentQuestions = yield select(getQuestionsArraySelector)
    const [testItem] = payload.data.itemGroups[0].items
    delete payload.data.alreadyLiked
    const testItemId = typeof testItem === 'object' ? testItem._id : testItem
    const resourceTypes = [
      questionType.VIDEO,
      questionType.PASSAGE,
      questionType.TEXT,
    ]

    const resources = assessmentQuestions.filter((q) =>
      resourceTypes.includes(q.type)
    )
    const questions = assessmentQuestions
      .filter((q) => !resourceTypes.includes(q.type))
      .map((q) =>
        QuestionsbyId[q.id]?.previousQuestionId
          ? {
              ...q,
              versionId: QuestionsbyId[q.id].versionId,
              previousQuestionId: QuestionsbyId[q.id].previousQuestionId,
            }
          : q
      )
    const updatedTestItem = {
      ...testItem,
      public: undefined,
      authors: undefined,
      version: testItem.version,
      isDocBased: true,
      data: {
        questions,
        resources,
      },
      rows: [
        {
          tabs: [],
          dimension: '100%',
          widgets: assessmentQuestions.map(createWidget),
        },
      ],
      itemLevelScoring: false,
    }

    const response = yield call(updateItemDocBasedSaga, {
      payload: {
        id: testItemId,
        data: updatedTestItem,
        keepData: true,
        redirect: false,
      },
    })

    const { testId, ...updatedItem } = response || {}

    // Updating the annotation question Id references using updated item question ids.
    if (
      updatedItem?.data?.questions?.length &&
      payload?.data?.annotations?.length
    ) {
      const versionedQIdMap = {}
      updatedItem.data.questions.forEach((question) => {
        const oldQId = question.previousQuestionId
        const newQId = question.id
        if (!!oldQId && oldQId !== newQId) {
          versionedQIdMap[oldQId] = newQId
        }
      })
      if (Object.keys(versionedQIdMap).length) {
        payload.data.annotations.forEach((annotation) => {
          if (versionedQIdMap[annotation.questionId]) {
            annotation.questionId = versionedQIdMap[annotation.questionId]
          }
        })
      }
    }

    const newAssessment = {
      ...payload.data,
      itemGroups: [
        {
          ...payload.data.itemGroups[0],
          items: [{ _id: testItemId, ...updatedItem }],
        },
      ],
    }

    const entityData = yield call(updateTestSaga, {
      payload: { ...payload, data: newAssessment },
    })
    return entityData
  } catch (err) {
    captureSentryException(err, {
      errorMessage: 'failed to update docbased test',
      saga: 'updateTestDocBasedSaga',
      data: payload,
    })
    const errorMessage = err?.data?.message || 'Unable to update the test.'
    notification({ type: 'error', msg: errorMessage })
    yield put(updateTestErrorAction(errorMessage))
    yield put(setUpdatingTestForRegradeStateAction(false))
  }
}

function* updateRegradeDataSaga({ payload: _payload }) {
  try {
    const { notify, ...payload } = _payload
    yield put(setRegradingStateAction(true))
    yield call(testsApi.publishTest, payload.newTestId)
    const { message, firestoreDocId } = yield call(
      assignmentApi.regrade,
      payload
    )
    yield put(setRegradeFirestoreDocId(firestoreDocId))
    if (notify) {
      notification({ type: 'info', msg: message })
    } else {
      notification({
        type: 'info',
        msg: 'Changes made to the test are being published',
      })
    }
  } catch (err) {
    const { data: { message: errorMessage } = {} } = err.response || {}
    captureSentryException(err)
    if (_payload.notify) {
      notification({
        type:
          errorMessage ===
          "You don't have the permission to publish this test type. Please reach out to an admin co-author to publish and regrade."
            ? 'warning'
            : 'error',
        msg: errorMessage || 'Unable to publish & regrade.',
      })
    } else {
      notification({
        type: 'error',
        msg: errorMessage || 'Publish failed',
      })
    }
    yield put(setRegradeFirestoreDocId(''))
    yield put(setRegradingStateAction(false))
  }
}

function* shareTestSaga({ payload }) {
  try {
    yield put(setSharingContentStateAction(true))
    const adminAuthorInfo = { ...payload.adminAuthorInfo }
    delete payload.adminAuthorInfo
    yield call(contentSharingApi.shareContent, payload)
    yield put(
      receiveSharedWithListAction({
        contentId: payload.contentId,
        contentType: payload.data.contentType,
      })
    )
    yield put(setSharingContentStateAction(false))
    if (adminAuthorInfo && adminAuthorInfo._id) {
      const entityTest = yield select(getTestEntitySelector)
      entityTest.adminCoAuthors = [
        ...(entityTest.adminCoAuthors || []),
        {
          ...adminAuthorInfo,
        },
      ]
      yield put(replaceTestDataAction(entityTest))
    }
    notification({ type: 'success', messageKey: 'sharedPlaylist' })
  } catch (err) {
    const {
      data: { message: errorMessage, invalidEmails = [] },
    } = err.response
    captureSentryException(err)
    const hasInvalidMails = invalidEmails.length > 0
    if (hasInvalidMails) {
      return notification({
        msg: `Invalid mails found (${invalidEmails.join(', ')})`,
      })
    }
    yield put(setSharingContentStateAction(false))
    notification({ msg: errorMessage || 'Sharing failed' })
  }
}

function* publishTestSaga({ payload }) {
  try {
    const { _id: id, test: _test, assignFlow, triggeredFrom } = payload
    if (!validateRestrictNavigationOut(_test)) {
      return
    }
    if (!validateTestForExpiredItems(_test)) {
      return
    }
    const defaultThumbnail = yield select(getDefaultThumbnailSelector)
    _test.thumbnail =
      _test.thumbnail === defaultImage ? defaultThumbnail : _test.thumbnail
    const assessmentQuestions = yield select(getQuestionsArraySelector)
    const resourceTypes = [
      questionType.VIDEO,
      questionType.PASSAGE,
      questionType.TEXT,
      questionType.COMBINATION_MULTIPART,
    ]
    const questions = assessmentQuestions.filter(
      (q) => !resourceTypes.includes(q.type)
    )

    const standardPresent = questions.some(hasStandards)
    // if alignment data is not present, set the flag to open the modal, and wait for
    // an action from the modal.!
    if (!standardPresent && _test.isDocBased) {
      yield put(togglePublishWarningModalAction(true))
      // action dispatched by the modal.
      const { payload: publishItem } = yield take(PROCEED_PUBLISH_ACTION)
      yield put(togglePublishWarningModalAction(false))

      // if he wishes to add some just close the modal, and go to metadata.
      // else continue the normal flow.
      if (!publishItem) {
        return
      }
    }

    const result = yield call(
      _test.isDocBased ? updateTestDocBasedSaga : updateTestSaga,
      {
        payload: { id, data: _test, assignFlow: true },
      }
    )

    if (!result) return

    yield put(resetUpdatedStateAction())

    const features = yield select(getUserFeatures)
    const districtId = yield select(getUserOrgId)
    const userId = yield select(getUserIdSelector)

    if (features.isPublisherAuthor && !assignFlow) {
      yield call(testsApi.updateTestStatus, {
        testId: id,
        status: testItemStatusConstants.INREVIEW,
      })
      yield put(updateTestStatusAction(testItemStatusConstants.INREVIEW))
      notification({ type: 'success', messageKey: 'reviewPlaylist' })
    } else {
      yield call(testsApi.publishTest, id)
      yield put(updateTestStatusAction(testItemStatusConstants.PUBLISHED))
      const customContentMetadata = getFromLocalStorage(
        `standardMasteryCustomContent:${districtId}:${userId}:${id}`
      )
      if (customContentMetadata) {
        segmentApi.genericEventTrack('CustomGeneratedTest:Publish', {
          origin: 'LCB:StandardBasedReport',
          testId: id,
          userId,
        })
      }
    }
    if (features.isCurator || features.isPublisherAuthor) {
      yield put(push(`/author/tests?filter=AUTHORED_BY_ME`))
      return notifyTestSaveOrPublishSuccess('testSavedSuccessfullyNotVisible')
    }
    if (!assignFlow) {
      notifyTestSaveOrPublishSuccess('publishedPlaylist')
    }
    if (assignFlow) {
      let update = {
        timedAssignment: _test?.timedAssignment,
        showRubricToStudents: _test.showRubricToStudents,
      }
      if (_test?.timedAssignment) {
        update = {
          ...update,
          allowedTime: _test?.allowedTime || 10 * 60 * 1000,
          pauseAllowed: _test?.pauseAllowed || false,
        }
      }
      /**
       * during assign flow , putting default settings
       */
      yield put(updateAssingnmentSettingsAction(update))
      // the state is used at src/client/author/AssignTest/components/Container/index.js to generate the segment event testAssignStart
      yield put(
        push(`/author/assignments/${id}`, {
          assessmentAssignedFrom: 'Created New',
          ...(triggeredFrom || {}),
        })
      )
    } else {
      const role = yield select(getUserRole)
      if (role !== roleuser.EDULASTIC_CURATOR)
        yield put(push(`/author/tests/${id}/publish`))
      else {
        const entityTest = yield select(getTestEntitySelector)
        entityTest.itemGroups.forEach((g) => {
          if (g.type === 'STATIC') {
            g.items.forEach((i) => {
              i.status = 'published'
            })
          }
        })
        yield put(updateTestEntityAction(entityTest))
      }
    }
  } catch (error) {
    if (error.status === 403) {
      return notification({
        type: 'warn',
        msg: error.message,
      })
    }
    const isCurator = yield select(getIsCurator)
    if (isCurator && error.status === 406) {
      return notification({
        type: 'warn',
        msg: error.message,
      })
    }
    Sentry.captureException(error)
    console.error(error)
    notification({
      type: 'warn',
      msg: error?.data?.message || error?.message || 'publish failed.',
    })
  }
}

/**
 *
 * @param {*} payload should be test ID
 */
function* publishForRegrade({ payload }) {
  try {
    yield put(setUpdatingTestForRegradeStateAction(true))
    // cloning the _test as it internally mutating the itemGroups inside updateTestSaga
    const _test = { ...(yield select(getTestSelector)) }
    if (_test.isUsed && !_test.isInEditAndRegrade) {
      _test.isInEditAndRegrade = true
    }
    if (!validateRestrictNavigationOut(_test)) {
      yield put(setUpdatingTestForRegradeStateAction(false))
      return
    }
    yield call(_test.isDocBased ? updateTestDocBasedSaga : updateTestSaga, {
      payload: {
        id: payload,
        data: _test,
        assignFlow: true,
        disableLoadingIndicator: true,
      },
    })
    const result = yield call(assignmentApi.fetchRegradeSettings, {
      oldTestId: _test.previousTestId,
      newTestId: payload,
    })
    yield put(setAvailableRegradeAction(result))
    const isRegradeNeeded = result.some(
      (item) => item === 'ADD' || item === 'EDIT'
    )
    if (isRegradeNeeded) {
      yield put(setShowRegradeConfirmPopupAction(true))
    } else {
      const districtId = yield select(getUserOrgId)
      yield put(setTestsLoadingAction(true))
      yield call(updateRegradeDataSaga, {
        payload: {
          notify: false,
          newTestId: payload,
          oldTestId: _test.previousTestId,
          assignmentList: [],
          districtId,
          applyChangesChoice: 'ALL',
          options: {
            removedQuestion: 'DISCARD',
            testSettings: 'ALL',
            addedQuestion: 'SKIP',
            editedQuestion: 'SCORE',
          },
        },
      })
    }
  } catch (error) {
    // This error is received when the old test had items from Access Restricted Collections (KDS).
    // Regrade is avoided in this scenario.
    if (error?.response?.data?.error === 'UNAUTHORIZED_REGRADE') {
      yield put(setAvailableRegradeAction([]))
      yield call(testsApi.publishTest, payload)
      yield put(updateTestStatusAction(testItemStatusConstants.PUBLISHED))
      return
    }
    Sentry.captureException(error)
    console.error(error)
    notification({ msg: error?.data?.message || 'publish failed.' })
  } finally {
    yield put(setUpdatingTestForRegradeStateAction(false))
  }
}

function* receiveSharedWithListSaga({ payload }) {
  try {
    const { sharedEntities = [], maxSharingLevelAllowed } = yield call(
      contentSharingApi.getSharedUsersList,
      payload
    )
    yield put(setMaxSharingLevelAllowedAction(maxSharingLevelAllowed))
    const coAuthors = sharedEntities.map(
      ({ permission, sharedWith, sharedType, _id }) => ({
        permission,
        sharedWith,
        sharedType,
        sharedId: _id,
      })
    )
    const testData = yield select(getTestEntitySelector)

    const testList = yield select((state) => state.testList.entities)
    const getTest = testList.find(
      (testItem) => testItem._id === payload.contentId
    )
    const v1LinkShareEnabled = testData._id
      ? testData.v1Attributes?.v1LinkShareEnabled === 1
      : getTest?.v1Attributes?.v1LinkShareEnabled === 1
    const v1Id = testData._id ? testData.v1Id : getTest?.v1Id

    if (
      (!coAuthors.length ||
        !coAuthors.some((item) => item.sharedType === 'LINK')) &&
      v1LinkShareEnabled
    ) {
      coAuthors.push({
        permission: 'VIEW',
        sharedWith: [],
        sharedType: 'LINK',
        sharedId: payload.contentId,
        v1LinkShareEnabled: 1,
        v1Id,
      })
    }
    yield put(updateSharedWithListAction(coAuthors))
    payload.callback?.()
  } catch (e) {
    Sentry.captureException(e)
    const errorMessage = 'Unable to retrieve shared list.'
    notification({ type: 'error', msg: errorMessage })
  }
}

function* deleteSharedUserSaga({ payload }) {
  try {
    yield call(contentSharingApi.deleteSharedUser, payload)
    if (payload.v1LinkShareEnabled === 1) {
      const testData = yield select(getTestEntitySelector)
      const testList = yield select((state) => state.testList.entities)
      const getTest = testList.find(
        (testItem) => testItem._id === payload.contentId
      )

      const updateTest = testData._id ? testData : getTest
      const { v1Attributes, ...rest } = updateTest

      yield put(replaceTestDataAction(rest))
    }
    if (payload.sharedId) {
      yield put(
        receiveSharedWithListAction({
          contentId: payload.contentId,
          contentType: payload.contentType,
        })
      )
    }
    const entityTest = yield select(getTestEntitySelector)
    entityTest.adminCoAuthors = (entityTest.adminCoAuthors || []).filter(
      (p) => p._id !== payload.sharedWith
    )
    yield put(replaceTestDataAction(entityTest))
  } catch (e) {
    const unshareCreatorErrorString = 'Cannot unshare test from the creator'
    if (e?.toString?.().includes(unshareCreatorErrorString)) {
      notification({
        type: 'warn',
        msg: 'The author of the test cannot be removed from the sharing list.',
      })
      return
    }
    Sentry.captureException(e)
    const errorMessage = 'Unable to remove the user.'
    notification({ type: 'error', msg: errorMessage })
  }
}

// TODO: analyse and refactor this logic.
function* setTestDataAndUpdateSaga({ payload }) {
  try {
    let newTest = yield select(getTestSelector)
    if (newTest.testType === TEST_TYPE_SURVEY) {
      newTest = produce(newTest, (draft) => {
        draft.scoringType = evalTypeLabels.ITEM_LEVEL_EVALUATION
      })
    }
    // Backend doesn't require PARTIAL_CREDIT_IGNORE_INCORRECT
    // Penalty true/false is set to determine the case
    if (
      newTest.scoringType === evalTypeLabels.PARTIAL_CREDIT_IGNORE_INCORRECT
    ) {
      newTest = produce(newTest, (draft) => {
        draft.scoringType = evalTypeLabels.PARTIAL_CREDIT
      })
    }
    const currentGroupIndex = yield select(getCurrentGroupIndexSelector)
    const { addToTest, item, passageItems = [] } = payload
    if (addToTest) {
      if (passageItems?.length) {
        yield put(setCorrectPassageItemsCreatedAction(passageItems))
      }
      const items = uniqBy([...passageItems, item], '_id')
      newTest = produce(newTest, (draft) => {
        // add only items that are already not present
        items.forEach((i) => {
          if (
            !draft?.itemGroups?.[currentGroupIndex]?.items?.find(
              (x) => x._id === i._id
            )
          ) {
            draft.itemGroups[currentGroupIndex].items.push(i)
          }
        })
      })
    } else {
      newTest = produce(newTest, (draft) => {
        draft.itemGroups = draft.itemGroups.map((itemGroup) => {
          if (itemGroup.type !== ITEM_GROUP_TYPES.AUTOSELECT) {
            itemGroup.items = itemGroup.items.filter(
              (el) => el._id !== item._id
            )
          }
          return itemGroup
        })
      })
    }
    // getting grades and subjects from each question array in test items
    const { itemGroups = [] } = newTest
    const testItems = itemGroups
      .filter(({ type }) => type !== ITEM_GROUP_TYPES.AUTOSELECT)
      .flatMap((itemGroup) => itemGroup.items || [])
    const questionGrades = testItems
      .flatMap((_item) => (_item.data && _item.data.questions) || [])
      .flatMap((question) =>
        question.grades && question.grades.length < 13 ? question.grades : []
      )
    const questionSubjects = testItems
      .flatMap((_item) => (_item.data && _item.data.questions) || [])
      .flatMap((question) => question.subjects || [])
    // alignment object inside questions contains subject and domains
    const getAlignmentsObject = testItems
      .flatMap((_item) => (_item.data && _item.data.questions) || [])
      .flatMap((question) => question.alignment || [])

    const subjects = getAlignmentsObject
      .map((alignment) => alignment.subject)
      .filter(identity)

    // domains inside alignment object holds standards with grades

    const grades = getAlignmentsObject
      .flatMap((alignment) => alignment?.domains)
      .flatMap((domain) => domain?.standards)
      .flatMap((standard) =>
        (standard?.grades?.length || 0) < 13 ? standard?.grades : []
      )
      .filter(identity)

    yield put(
      getItemsSubjectAndGradeAction({
        subjects: _uniq([...subjects, ...questionSubjects]),
        grades: _uniq([...grades, ...questionGrades]),
      })
    )

    yield put(setTestDataAction(newTest))
    const creating = yield select(getTestsCreatingSelector)
    if (newTest._id || creating) {
      return
    }
    yield put(setIsCreatingAction(true))
    if (newTest.thumbnail === defaultImage) {
      const thumbnail = yield call(testsApi.getDefaultImage, {
        subject: get(newTest, 'data.subjects[0]', 'Other Subjects'),
        standard: get(newTest, 'data.summary.standards[0].identifier', ''),
      })
      yield put(updateDefaultThumbnailAction(thumbnail))
    }

    if (!newTest._id) {
      const { title } = newTest
      const role = yield select(getUserRole)
      if (!title) {
        return notification({ messageKey: 'nameShouldNotEmpty' })
      }
      if (
        newTest.passwordPolicy !==
        passwordPolicy.REQUIRED_PASSWORD_POLICY_DYNAMIC
      ) {
        delete newTest.passwordExpireIn
      }
      if (
        newTest.passwordPolicy !==
        passwordPolicy.REQUIRED_PASSWORD_POLICY_STATIC
      ) {
        delete newTest.assignmentPassword
      } else if (!newTest.assignmentPassword) {
        notification({ messageKey: 'enterValidPassword' })
        return
      }
      const isDistrictSuperAdmin = yield select(
        isUserDistrictSuperAdminSelector
      )
      const userTestTypesInternal = yield select(getUserTestTypes)
      let testObj = produce(newTest, (draft) => {
        draft.itemGroups = transformItemGroupsUIToMongo(draft.itemGroups)
        const isContentVisibilityRestricted = isContentVisibilityRestrictedForCurrentUser(
          {
            isTestContentRestrictedBySuperAdmin:
              newTest?.isTestContentRestrictedBySuperAdmin,
            userRole: role,
            isDistrictSuperAdmin,
            testType: newTest?.testType,
            userTestTypesInternal,
          }
        )
        if (!newTest.testContentVisibility && !isContentVisibilityRestricted) {
          draft.testContentVisibility =
            testConstants.testContentVisibility.ALWAYS
        }
      })
      // summary CAN BE REMOVED AS BE WILL CREATE ITS OWN SUMMARY USING ITEMS
      // passages doesnt accepted by BE
      const omitedItems = ['passages', 'summary', 'alreadyLiked']
      const allTestTypesInternal = yield select(getTestTypesFormatedConstant)
      const allTestTypesInternalList = _.flatten(
        Object.values(allTestTypesInternal)
      )
      if (
        !allTestTypesInternal.COMMON.includes(testObj.testType) &&
        allTestTypesInternalList.includes(testObj.testType)
      ) {
        testObj.freezeSettings = false
        testObj.allowTeacherRedirect = true
        testObj.testContentVisibility = 'ALWAYS'
      }
      testObj = omit(testObj, omitedItems)
      const entity = yield call(testsApi.create, testObj)
      const { itemGroups: _itemGroups } = yield select(getTestSelector)
      yield put({
        type: UPDATE_ENTITY_DATA,
        payload: {
          entity: { ...entity, itemGroups: _itemGroups },
        },
      })
      yield put(setIsCreatingAction(false))

      // redirecting to edit-item page instead of test review page if after creating a passage item
      if (payload.fromSaveMultipartItem) {
        if (!isEmpty(payload.routerState)) {
          yield put(
            push({
              pathname: payload.url.replace(
                'tests/undefined',
                `tests/${entity?._id || 'undefined'}`
              ),
              state: payload.routerState,
            })
          )
        } else {
          yield put(
            push(
              payload.url.replace(
                'tests/undefined',
                `tests/${entity?._id || 'undefined'}`
              )
            )
          )
        }
        return
      }
      // TODO: is this logic still relevant?
      if (payload.current) {
        yield put(
          replace(`/author/tests/tab/${payload.current}/id/${entity._id}`)
        )
      } else if (item.isPassageWithQuestions) {
        yield put(replace(`/author/tests/tab/review/id/${entity._id}`))
      } else {
        yield put(
          replace({
            pathname: `/author/tests/tab/review/id/${entity._id}`,
            state: {
              showItemAddedMessage: true,
              isAuthoredNow: true,
              scrollToBottom: true,
            },
            ...getSearchParams(),
          })
        )
      }
      notification({
        type: 'success',
        msg: `Your work is automatically saved as a draft assessment named ${entity.title}`,
      })
    }

    // if item has passage, add the passage to test as well. (review tab requires it)
    if (item.passageId) {
      const currentPassages = yield select(getCurentTestPassagesSelector)
      const currentPassageIds = currentPassages.map((i) => i._id)
      const newPayload = {}
      if (!currentPassageIds.includes(item.passageId)) {
        const passage = yield call(passageApi.getById, item.passageId)
        newPayload.passages = [...currentPassages, passage]
        yield put(setTestDataAction(newPayload))
      }
    }
  } catch (err) {
    const {
      data: { message: errorMessage },
    } = err.response
    captureSentryException(err)

    notification({
      type: 'error',
      msg: errorMessage || 'Unable to save test.',
    })
  }
}

function* getEvaluation(testItemId, newScore) {
  const testItems = yield select(getTestItemsSelector)
  const equivalentItems = yield select(getEquivalentItemsSelector)
  const testItem =
    [...testItems, ...equivalentItems].find((x) => x._id === testItemId) || {}
  const {
    itemLevelScore,
    itemLevelScoring = false,
    itemGradingType,
    assignPartialCredit,
  } = testItem
  const languageTestItem = produce(testItem, (draft) => {
    if (draft?.data?.questions) {
      draft.data.questions = draft.data.questions.map((question) => {
        return changeDataToPreferredLanguage(question, LANGUAGE_EN, PREVIEW)
      })
    }
  })
  const languageQuestions = _keyBy(languageTestItem?.data?.questions, 'id') // here we need to translate
  const answers = yield select((state) => get(state, 'answers', {}))
  const answersByQids = answersByQId(answers, testItem._id)
  if (!hasValidResponse(answersByQids, languageQuestions)) {
    return
  }
  const evaluation = yield evaluateItem(
    answersByQids,
    languageQuestions,
    itemLevelScoring,
    newScore,
    itemLevelScore,
    testItem._id,
    itemGradingType,
    assignPartialCredit
  )
  return evaluation
}

function* getEvaluationFromItem(testItem, newScore) {
  const {
    itemLevelScore,
    itemLevelScoring = false,
    itemGradingType,
    assignPartialCredit,
  } = testItem
  const languageTestItem = produce(testItem, (draft) => {
    if (draft?.data?.questions) {
      draft.data.questions = draft.data.questions.map((question) => {
        return changeDataToPreferredLanguage(question, LANGUAGE_EN, PREVIEW)
      })
    }
  })
  const languageQuestions = _keyBy(languageTestItem?.data?.questions, 'id')
  const answers = yield select((state) => get(state, 'answers', {}))
  const answersByQids = answersByQId(answers, testItem._id)
  if (!hasValidResponse(answersByQids, languageQuestions)) {
    return
  }
  const evaluation = yield evaluateItem(
    answersByQids,
    languageQuestions,
    itemLevelScoring,
    newScore,
    itemLevelScore,
    testItem._id,
    itemGradingType,
    assignPartialCredit
  )
  return evaluation
}

function* checkAnswerSaga({ payload }) {
  try {
    let evaluationObject = {}
    const { scoring } = yield select(getTestEntitySelector)
    if (payload.isItem) {
      evaluationObject = yield getEvaluationFromItem(
        payload,
        scoring[payload._id]
      )
    } else {
      evaluationObject = yield getEvaluation(payload.id, scoring[payload.id])
    }
    if (isEmpty(evaluationObject)) {
      yield put({
        type: CHANGE_PREVIEW,
        payload: {
          view: 'check',
        },
      })
      return notification({
        type: 'warn',
        messageKey: 'attemptTheQuestonToCheckAnswer',
      })
    }
    const { evaluation, score, maxScore } = evaluationObject
    yield put({
      type: CHANGE_PREVIEW,
      payload: {
        view: 'check',
      },
    })

    yield put({
      type: SET_ITEM_SCORE,
      payload: {
        score: round(score, 2),
        maxScore,
        showScore: true,
      },
    })

    yield put({
      type: ADD_ITEM_EVALUATION,
      payload: {
        ...evaluation,
      },
    })

    // message.success(`score: ${+score.toFixed(2)}/${maxScore}`);
  } catch (e) {
    Sentry.captureException(e)
    notification({ messageKey: 'checkAnswerFailed' })
    console.log('error checking answer', e)
  }
}

function* showAnswerSaga({ payload = {} }) {
  try {
    const testItems = yield select(getTestItemsSelector)
    const testItem = testItems.find((x) => x._id === payload.id) || {}
    const answers = yield select((state) => get(state, 'answers', {}))

    const languageTestItem = produce(testItem, (draft) => {
      if (draft?.data?.questions) {
        draft.data.questions = draft.data.questions.map((question) => {
          return changeDataToPreferredLanguage(question, LANGUAGE_EN, PREVIEW)
        })
      }
    })
    let languageQuestions = _keyBy(
      languageTestItem?.data?.questions || [],
      'id'
    )

    // when item is removed from the test, we get the question from the payload (i.e modal case)
    if (!languageQuestions || Object.keys(languageQuestions).length === 0) {
      const data = (payload.item ? payload.item.data : payload.data) || {
        questions: [],
      }

      const languageTestItemData = produce(data, (draft) => {
        if (draft?.questions) {
          draft.questions = draft.questions.map((question) => {
            return changeDataToPreferredLanguage(question, LANGUAGE_EN, PREVIEW)
          })
        }
      })

      // eslint-disable-next-line prefer-destructuring
      languageQuestions = (languageTestItemData?.questions || []).reduce(
        (acc, curr) => {
          acc[curr.id] = curr
          return acc
        },
        {}
      )
    }
    yield put({
      type: CHANGE_PREVIEW,
      payload: {
        view: 'show',
      },
    })

    const evaluation = yield createShowAnswerData(
      languageQuestions,
      answers,
      testItem._id || payload._id
    )
    yield put({
      type: ADD_ITEM_EVALUATION,
      payload: {
        ...evaluation,
      },
    })
  } catch (e) {
    Sentry.captureException(e)
    notification({ messageKey: 'loadAnswerFailed' })
    console.log('error showing answer', e)
  }
}

/** TODO: If this needs to be wired to UI say for loading etc, please move it to redux store
 *  This is meant only for dependent sagas to wait upon if in loading state.
 */
export const TAGS_SAGA_FETCH_STATUS = {
  isLoading: false,
}

function* getAllTagsSaga({ payload }) {
  const tagType = Array.isArray(payload.type) ? payload.type[0] : payload.type
  try {
    TAGS_SAGA_FETCH_STATUS.isLoading = true
    const tags = yield call(tagsApi.getAll, payload.type)
    yield put({
      type: SET_ALL_TAGS,
      payload: { tags, tagType },
    })
  } catch (e) {
    Sentry.captureException(e)
    yield put({
      type: SET_ALL_TAGS_FAILED,
      payload: { tagType },
    })
    notification({ messageKey: 'getAllTagsFailed' })
  } finally {
    TAGS_SAGA_FETCH_STATUS.isLoading = false
  }
}

function* searchTagsSaga({ payload }) {
  try {
    const result = yield call(tagsApi.searchTags, payload)
    let tags = []
    if (payload.aggregate) {
      for (const [key, value] of Object.entries(result)) {
        tags.push({
          _id: key,
          tagName: key,
          tagType: payload?.search?.tagTypes?.[0],
          tagNamesAssociated: value,
        })
      }
    } else {
      const hits = get(result, 'hits.hits', [])
      tags = hits.map(({ _id, _source }) => ({
        _id,
        ..._source,
      }))
    }
    yield put({
      type: SEARCH_TAG_LIST_SUCCESS,
      payload: tags,
    })
    yield put({
      type: APPEND_KNOWN_TAGS,
      payload: tags,
    })
  } catch (e) {
    Sentry.captureException(e)
    yield put({
      type: SEARCH_TAG_LIST_ERROR,
    })
  }
}

function* searchTagsByIdSaga({ payload: ids }) {
  try {
    const payload = {
      page: 1,
      limit: Math.max(1, ids.length),
      search: {
        ids,
      },
    }
    yield* searchTagsSaga({ payload })
  } catch (err) {
    Sentry.captureException(err)
  }
}

function* getDefaultTestSettingsSaga({ payload: testEntity }) {
  try {
    yield put(setDefaultSettingsLoadingAction(true))
    const role = yield select(getUserRole)
    const districtId = yield select(getUserOrgId)
    const institutionIds = yield select(currentDistrictInstitutionIds)
    let payload = {
      orgId: districtId,
      params: { orgType: 'district' },
    }

    if (role !== roleuser.DISTRICT_ADMIN && institutionIds.length) {
      payload = {
        orgId: institutionIds[0] || districtId,
        params: {
          orgType: 'institution',
        },
      }
    }
    let defaultTestSettings = {}
    if (role !== roleuser.EDULASTIC_CURATOR) {
      const currentSignupState = yield select(getUserSignupStatusSelector)
      if (
        role === roleuser.TEACHER &&
        currentSignupState == signUpState.ACCESS_WITHOUT_SCHOOL
      ) {
        const userId = yield select(getUserIdSelector)
        defaultTestSettings = yield call(testsApi.getDefaultTestSettings, {
          orgId: userId,
          params: { orgType: 'teacher' },
        })
      } else {
        defaultTestSettings = yield call(
          testsApi.getDefaultTestSettings,
          payload
        )
      }
    } else {
      const { performanceBand, standardGradingScale } = testEntity
      const performanceBandProfiles = [performanceBand]
      const standardsProficiencyProfiles = [standardGradingScale]
      const performanceBandId = performanceBand._id
      const standardProficiencyId = standardGradingScale._id
      const defaultTestTypeProfiles = {
        performanceBand: {
          common: performanceBandId,
          assessment: performanceBandId,
          practice: performanceBandId,
        },
        standardProficiency: {
          common: standardProficiencyId,
          assessment: standardProficiencyId,
          practice: standardProficiencyId,
        },
      }
      defaultTestSettings = {
        performanceBandProfiles,
        standardsProficiencyProfiles,
        defaultTestTypeProfiles,
      }
    }
    const allTestTypesInternal = yield select(getTestTypesFormatedConstant)
    const {
      performanceBandProfiles,
      standardsProficiencyProfiles,
      defaultTestTypeProfiles: defaultTestProfiles,
      partialScore,
      canSchoolAdminUseDistrictCommon,
      canTeacherAuthorCommonTests,
      enableUploadWork = true,
    } = defaultTestSettings
    yield put(
      setCanSchoolAdminUseDistrictCommonAction(canSchoolAdminUseDistrictCommon)
    )
    yield put(setCanTeacherAuthorCommonTestAction(canTeacherAuthorCommonTests))
    yield put(receivePerformanceBandSuccessAction(performanceBandProfiles))
    yield put(
      receiveStandardsProficiencySuccessAction(standardsProficiencyProfiles)
    )
    yield put(
      setDefaultTestTypeProfilesAction({
        ...defaultTestSettings,
        allTestTypesInternal,
      })
    )
    const performanceBand =
      testEntity?.performanceBand ||
      getDefaultSettings({
        testType: testEntity?.testType,
        defaultTestProfiles,
        allTestTypesInternal,
      })?.performanceBand
    const standardGradingScale =
      testEntity?.standardGradingScale ||
      getDefaultSettings({
        testType: testEntity?.testType,
        defaultTestProfiles,
        allTestTypesInternal,
      })?.standardProficiency
    const testData = yield select(getTestSelector)
    const userId = yield select(getUserId)
    const isAuthor = testData.authors?.some((author) => author._id === userId)
    if (!testData.freezeSettings || isAuthor) {
      yield put(
        updateAssingnmentSettingsAction({
          performanceBand,
          standardGradingScale,
        })
      )
    }
    if ((!testData._id || !testData.title) && partialScore === false) {
      yield put(
        setTestDataAction({
          scoringType: evalTypeLabels.ALL_OR_NOTHING,
        })
      )
    }
    if ((!testData._id || !testData.title) && enableUploadWork === true) {
      // apply default value from district settings
      yield put(
        setTestDataAction({
          enableUploadWork,
        })
      )
    }
    yield put(setDefaultSettingsLoadingAction(false))
    if (testEntity?.saveDefaultTestSettings === true) {
      const _test = yield select(getTestEntitySelector)
      const defaultSettings = pick(
        _test,
        getSettingsToSaveOnTestType(_test.isDocBased)
      )
      yield put(setDefaultTestSettingsAction(defaultSettings))
    }
  } catch (e) {
    Sentry.captureException(e)
    notification({ messageKey: 'getDeafultSettingsFailed' })
    yield put(setDefaultSettingsLoadingAction(false))
  }
}

function* duplicateTestSaga({ payload }) {
  yield put(setTestsLoadingAction(true))
  const { onRegrade = false, searchParam = '' } = payload
  try {
    const {
      _id,
      title,
      currentTab,
      isInEditAndRegrade = false,
      redirectToNewTest = false,
      playlistId,
      updatePlaylist = false,
      updateContentVersionId = false,
    } = payload
    const queryParams = {
      _id,
      title,
      isInEditAndRegrade,
      playlistId,
      updatePlaylist,
      updateContentVersionId,
    }
    const data = yield call(assignmentApi.duplicateAssignment, queryParams)

    if (data?.testCategory === testCategoryTypes.VIDEO_BASED) {
      const { vqUsageCount } = yield call(getVQUsageCountApi.getVQUsageCount)
      yield put(
        setUserFeaturesAction({
          featureName: 'vqUsageCount',
          value: vqUsageCount,
        })
      )
    }
    const searchObj =
      data?.testType === TEST_TYPE_SURVEY
        ? { search: `testType=${TEST_TYPE_SURVEY}` }
        : {}
    if (redirectToNewTest) {
      // cloning from test review page or test library (non-regrade flow)
      yield put(
        push({
          pathname: `/author/tests/${data._id}${searchParam}`,
          ...searchObj,
        })
      )
      yield put(setEditEnableAction(true))
      yield put(setTestsLoadingAction(false))
      yield put(receiveTestByIdAction(data._id, true))
      return
    }
    yield put(
      push({
        pathname: `/author/tests/tab/${currentTab}/id/${data._id}/old/${_id}`,
        ...searchObj,
      })
    )
    yield put(setTestsLoadingAction(false))
    yield put(receiveTestByIdAction(data._id, true))
    notification({ msg: 'You are currently editing a cloned test' })
  } catch (err) {
    const { data = {} } = err.response || {}
    const { message: errorMessage } = data
    captureSentryException(err)
    yield put(setTestsLoadingAction(false))
    yield put(setEditEnableAction(false))
    if (err?.status === 403) {
      if (onRegrade === true) {
        yield put(setTestDataAction({ isUsed: false }))
        yield put(setCreateSuccessAction())
        return notification({
          msg: 'Duplicating the test permission denied and failed to regrade',
        })
      }
      if (errorMessage === VQ_QUOTA_EXHAUSTED) {
        const vqQuotaForDistrict = yield select(vqQuotaForDistrictSelector)
        return notification({
          type: 'warn',
          msg: `You have reached the maximum limit of ${vqQuotaForDistrict} tests for VideoQuiz.`,
        })
      }

      return notification({
        msg:
          err?.message || 'You do not have the permission to clone the test.',
      })
    }

    return notification({ msg: errorMessage || 'Failed to duplicate test' })
  }
}

/*
 * add passage items to test.
 * dispatched when user want to add all items of passage to the test.
 */
function* setAndSavePassageItems({ payload: { passageItems, page, remove } }) {
  try {
    const cart = page === 'itemList'
    const currentGroupIndex = yield select(getCurrentGroupIndexSelector)
    const _test = yield select(cart ? getCartTestSelector : getTestSelector)
    const hasSections = yield select(
      cart ? isCartTestHasSectionsSelector : hasSectionsSelector
    )
    const isDynamicTest = yield select(
      cart ? isCartTestDynamicSelector : isDynamicTestSelector
    )
    const { passageId } = passageItems?.[0] || {}
    const currentPassages = yield select(
      cart ? getCartTestPassagesSelector : getCurentTestPassagesSelector
    )
    const currentPassageIds = currentPassages.map((i) => i._id)
    // new payload to update the tests' store's entity.
    const newPayload = {}
    // if passage is not already present, fetch it and add it to the payload.
    if (!currentPassageIds.includes(passageId)) {
      const passage = yield call(passageApi.getById, passageId)
      newPayload.passages = [...currentPassages, passage]
    }
    const testItems = yield select(
      cart ? getCartTestItemsSelector : getSelectedTestItemsSelector
    )
    newPayload.itemGroups = _test.itemGroups
    if (remove) {
      const passageItemIds = passageItems.map((x) => x._id)
      /**
       * ref: EV-41116
       * For sections and dynamic test first item from passage can exist in group 1
       * and second item from same passage can exist in group 2
       * Thus when removing passage items need to filter from all groups and not
       * only from current group index.
       */
      if (hasSections || isDynamicTest) {
        ;(newPayload.itemGroups || []).forEach((currentItemGroup, index) => {
          const currentGroupItems = currentItemGroup?.items || []
          if (currentGroupItems.length) {
            newPayload.itemGroups[index].items = uniqBy(
              currentGroupItems.filter((x) => !passageItemIds.includes(x._id)),
              (x) => x._id
            )
          }
        })
      } else {
        newPayload.itemGroups[currentGroupIndex].items = uniqBy(
          testItems.filter((x) => !passageItemIds.includes(x._id)),
          (x) => x._id
        )
      }
    } else {
      let newItems = [...testItems]
      /**
       * ref: EV-41010
       * For sections and dynamic test read existing items from respective current group,
       * and not read items from all groups to prevent addition of same items
       * in multiple multiple groups.
       */
      if (
        (hasSections || isDynamicTest) &&
        typeof currentGroupIndex === 'number'
      ) {
        const testItemsInCurrentGroup =
          _test.itemGroups?.[currentGroupIndex]?.items || []
        newItems = [...testItemsInCurrentGroup]
      }
      const lastIdx = findLastIndex(
        newItems,
        (element) => element.passageId === passageId
      )
      if (lastIdx !== -1) {
        newItems.splice(lastIdx + 1, 0, ...passageItems)
      } else newItems = [...newItems, ...passageItems]
      newPayload.itemGroups[currentGroupIndex].items = uniqBy(
        newItems,
        (x) => x._id
      )
    }
    const itemIds = _uniq(
      newPayload.itemGroups
        .flatMap((itemGroup) => itemGroup.items || [])
        .map((i) => i._id)
    )
    if (!_test._id && page !== 'itemList') {
      yield put(createTestAction({ ..._test, ...newPayload }))
    }
    newPayload.cart = cart
    // for weird reason there is another store to show if a testItem should be shown
    // as selected or not in item banks page. Adding test items to there.
    yield put(setTestItemsAction(itemIds))
    // update the test data wth testItems, and passage if needed.
    yield put(setTestDataAction(newPayload))
  } catch (e) {
    Sentry.captureException(e)
    notification({ messageKey: 'errorAddingPassageItems' })
    console.error('error', e, e.stack)
  }
}

/**
 * this saga is used to update the test before navigation.
 *  like, you want to move to edit/create item.. so save the test before navigating.
 *
 */
function* updateTestAndNavigate({ payload }) {
  try {
    let { pathname } = payload
    const {
      fadeSidebar = false,
      regradeFlow,
      previousTestId,
      testId,
      isEditing,
      isDuplicating,
      scrollToBottom,
      isSectionAdaptiveTest,
      testUpdateInProgress = false,
      requestSave = false,
    } = payload
    const data = { ...(yield select(getTestSelector)) }
    const role = yield select(getUserRole)
    const hasUnsavedChanges = yield select((state) => state?.tests?.updated)
    const isDistrictSuperAdmin = yield select(isUserDistrictSuperAdminSelector)
    const userTestTypesInternal = yield select(getUserTestTypes)
    const isContentVisibilityRestricted = isContentVisibilityRestrictedForCurrentUser(
      {
        isTestContentRestrictedBySuperAdmin:
          data?.isTestContentRestrictedBySuperAdmin,
        userRole: role,
        isDistrictSuperAdmin,
        testType: data?.testType,
        userTestTypesInternal,
      }
    )
    if (hasUnsavedChanges && !testUpdateInProgress) {
      const isTestCreated = testId && testId !== 'undefined'
      const allTestTypesInternal = yield select(getTestTypesFormatedConstant)
      if (
        !isTestCreated &&
        allTestTypesInternal.COMMON.includes(data.testType) &&
        !isContentVisibilityRestricted &&
        !data.testContentVisibility
      ) {
        data.testContentVisibility = testConstants.testContentVisibility.ALWAYS
      }
      const _test = !isTestCreated ? yield createTest(data) : {}
      if ((isEditing || isDuplicating) && isTestCreated) {
        yield updateTestSaga({ payload: { data, id: testId } })
      }
      if (!isTestCreated) {
        pathname = pathname.replace('undefined', _test._id)
      }
    }
    yield put(setScrollToBottomAction(scrollToBottom))
    yield put(
      push({
        pathname,
        state: {
          isTestFlow: true,
          fadeSidebar,
          regradeFlow,
          previousTestId,
          isSectionAdaptiveTest,
          requestSave,
          testSubjects: data.subjects || [],
          testGrades: data.grades || [],
        },
        ...getSearchParams('testType'),
      })
    )
  } catch (e) {
    Sentry.captureException(e)
    notification({ messageKey: 'errorUpdatingTest' })
    console.error('err', e)
  }
}

function* approveOrRejectSingleTestSaga({ payload }) {
  try {
    if (
      payload.status === 'published' &&
      (!payload.collections ||
        (payload.collections && !payload.collections.length))
    ) {
      notification({
        type: 'warn',
        messageKey: 'testNotAssociatedWithCollection',
      })
      return
    }
    payload = omit(payload, ['alreadyLiked'])
    yield call(testsApi.updateTestStatus, payload)
    yield put(approveOrRejectSingleTestSuccessAction(payload))
    notification({
      type: 'success',
      msg: `Test ${
        payload.status === 'published' ? 'Approved' : 'Rejected'
      } Successfully.`,
    })
    yield put(push('/author/tests'))
  } catch (error) {
    Sentry.captureException(error)
    console.error(error)
    notification({
      msg:
        error?.data?.message ||
        `Test ${payload.status === 'published' ? 'Approve' : 'Reject'} Failed.`,
    })
  }
}

function tranformItemGroupToData(itemGroup, index, allStaticGroupItemIds) {
  const optionalFields = {
    depthOfKnowledge: itemGroup.dok,
    authorDifficulty: itemGroup.difficulty,
    tags: itemGroup.tags?.map((tag) => tag.tagName) || [],
  }
  Object.keys(optionalFields).forEach(
    (key) => optionalFields[key] === undefined && delete optionalFields[key]
  )
  return {
    data:
      itemGroup.type === ITEM_GROUP_TYPES.STATIC
        ? null
        : {
            limit: itemGroup.deliverItemsCount,
            search: {
              collectionId: itemGroup.collectionDetails._id,
              standardIds:
                itemGroup?.standardDetails?.standards?.map(
                  (std) => std.standardId
                ) || [],
              nInItemIds: allStaticGroupItemIds,
              ...optionalFields,
            },
          },
    isFetchItems:
      itemGroup.type === ITEM_GROUP_TYPES.AUTOSELECT &&
      !itemGroup.premiumContentRestriction,
    groupName: itemGroup.groupName,
    index,
  }
}

function getItemGroupsTransformed(_test) {
  const allStaticGroupItemIds = getStaticGroupItemIds(_test)
  return _test.itemGroups.map((itemGroup, index) =>
    tranformItemGroupToData(itemGroup, index, allStaticGroupItemIds)
  )
}

function* fetchAutoselectGroupItemsSaga(payload) {
  try {
    const response = yield call(testItemsApi.getAutoSelectedItems, payload)
    return response.items.map((i) => ({ ...i, autoselectedItem: true }))
  } catch (err) {
    captureSentryException(err)
    console.error(err)
    notification({ messageKey: 'failedToFetchAutoselectItems' })
    return null
  }
}

function* addItemsToAutoselectGroupsSaga({ payload: _test }) {
  try {
    const hasAutoSelectItems = _test.itemGroups.some(
      (g) =>
        g.type === testConstants.ITEM_GROUP_TYPES.AUTOSELECT && !g.items?.length
    )
    if (!hasAutoSelectItems) return
    yield put(setAutoselectItemsFetchingStatusAction(true))
    const transformedData = getItemGroupsTransformed(_test)
    for (const { isFetchItems, data, groupName } of transformedData) {
      if (isFetchItems) {
        const response = yield fetchAutoselectGroupItemsSaga(data)
        if (response) {
          yield put(
            addItemsToAutoselectGroupAction({ items: response, groupName })
          )
        }
      }
    }
    yield put(setAutoselectItemsFetchingStatusAction(false))
  } catch (err) {
    captureSentryException(err)
    yield put(setAutoselectItemsFetchingStatusAction(false))
    console.error(err)
  }
}

export function* addAutoselectGroupItems({ payload: _test }) {
  try {
    const transformedData = getItemGroupsTransformed(_test)
    const allStaticGroupItemIds = getStaticGroupItemIds(_test)
    const promises = transformedData.map(({ data, isFetchItems }) => {
      if (isFetchItems) {
        return testItemsApi
          .getAutoSelectedItems({
            ...data,
            search: { ...data.search, nInItemIds: allStaticGroupItemIds },
          })
          .then((response) => ({ ...response }))
      }
      return Promise.resolve(null)
    })

    const responses = yield Promise.all(promises)
    const itemGroups = _test.itemGroups.map((itemGroup, i) => {
      if (
        itemGroup.type === ITEM_GROUP_TYPES.AUTOSELECT &&
        transformedData?.[i].isFetchItems
      ) {
        return { ...itemGroup, items: responses[i].items }
      }
      return itemGroup
    })

    return { ..._test, itemGroups }
  } catch (err) {
    captureSentryException(err)
    console.error(err)
  }
}

function* toggleTestLikeSaga({ payload }) {
  try {
    if (payload.contentType === 'TEST')
      yield put(updateTestLikeCountAction(payload))
    else yield put(updateTestItemLikeCountAction(payload))
    yield call(analyticsApi.toggleLike, payload)
  } catch (e) {
    Sentry.captureException(e)
    console.error(e)
    payload = {
      ...payload,
      toggleValue: !payload.toggleValue,
    }
    if (payload.contentType === 'TEST')
      yield put(updateTestLikeCountAction(payload))
    else yield put(updateTestItemLikeCountAction(payload))
  }
}

function* getTestIdFromVersionIdSaga({ payload }) {
  try {
    const { testId } = yield call(testsApi.getTestIdFromVersionId, payload)
    if (testId) {
      yield put(push(`/author/tests/tab/review/id/${testId}`))
      yield put(receiveTestByIdAction(testId, true, false))
    }
  } catch (err) {
    Sentry.captureException(err)
    console.error(err)
    yield put(resetUpdatedStateAction())
    const errorMessage =
      'You can no longer use this, as sharing access has been revoked by author'
    yield put(push('/author/tests'))
    if (err.status === 403) {
      notification({
        type: 'error',
        msg: err?.response?.data?.message || null,
        messageKey: 'curriculumMakeApiErr',
        exact: true,
      })
    } else {
      notification({ msg: errorMessage })
    }
  }
}

function* getRegradeSettingsSaga({ payload }) {
  try {
    const result = yield call(assignmentApi.fetchRegradeSettings, payload)
    yield put(setAvailableRegradeAction(result))
  } catch (err) {
    Sentry.captureException(err)
    console.error(err)
  }
}

function* fetchSavedTestSettingsListSaga({ payload }) {
  try {
    const settingsList = yield call(settingsApi.getTestSettingsList, payload) ||
      []
    yield put(
      setTestSettingsListAction(
        settingsList.filter((setting) => !!setting?.title)
      )
    )
  } catch (err) {
    Sentry.captureException(err)
  }
}

function* saveTestSettingsSaga({ payload }) {
  try {
    const testSettingsToSave = removeTestTTSFromTestSettings(payload.data)
    const result = yield call(settingsApi.createTestSetting, testSettingsToSave)
    if (payload.switchSetting)
      yield put(setCurrentTestSettingsIdAction(result._id))
    if (payload.switchSettingInTest)
      yield put(setTestDataAction({ settingId: result._id }))
    yield put(addTestSettingInList(result))
    notification({ type: 'success', msg: 'Test settings saved successfully' })
  } catch (err) {
    Sentry.captureException(err)
    const errorMessage =
      err?.response?.data?.message || 'Failed to save test settings'
    notification({ type: 'error', msg: errorMessage })
  }
}

function* deleteTestSettingRequestSaga({ payload }) {
  try {
    const { testSettingsId } = payload
    yield call(settingsApi.removeTestSetting, payload)
    yield put(removeTestSettingFromList(testSettingsId))
    notification({ type: 'success', msg: 'Test setting removed successfully' })
  } catch (err) {
    Sentry.captureException(err)
    const errorMessage =
      err?.response?.data?.message || 'Failed to delete test setting'
    notification({ type: 'error', msg: errorMessage })
  }
}

function* updateTestSettingRequestSaga({ payload }) {
  try {
    const testSettingsToSave = removeTestTTSFromTestSettings(payload)
    const result = yield call(settingsApi.updateTestSetting, testSettingsToSave)
    yield put(updateTestSettingInList(result))
    notification({ type: 'success', msg: 'Test setting updated successfully' })
  } catch (err) {
    Sentry.captureException(err)
    const errorMessage =
      err?.response?.data?.message || 'Failed to udate test setting'
    notification({ type: 'error', msg: errorMessage })
  }
}
function* getYoutubeThumbnailRequestSaga({ payload }) {
  try {
    const result = yield call(testsApi.getYoutubeThumbnail, payload)
    yield put({
      type: GET_YOUTUBE_THUMBNAIL_SUCCESS,
      payload: result?.cdnLocation,
    })
  } catch (err) {
    yield put(setYoutubeThumbnailFailure())
    Sentry.captureException(err)
    const errorMessage =
      err?.response?.data?.message || 'Failed to get thumbnail'
    notification({ type: 'error', msg: errorMessage })
  }
}

function* replaceRestrictedItemSaga({ payload }) {
  try {
    const items = yield call(testItemsApi.getEquivalentItems, payload)
    const testItems = yield select(getTestItemsSelector)
    const testItemsIds = testItems.map(({ _id }) => _id)
    const filterTestItems = items.filter(
      ({ _id }) => !testItemsIds.includes(_id)
    )
    if (filterTestItems && filterTestItems.length) {
      // TODO set to a state for displaying in popup
      yield put(setReplaceItemsAction(filterTestItems))
      yield put(setModalVisibilityAction(true))
    } else {
      const testId = yield select(getTestIdSelector)
      if (testId) yield put(push(`/author/tests/tab/addItems/id/${testId}`))
      // navigate to add items page
    }
  } catch (err) {
    Sentry.captureException(err)
    const errorMessage = err?.response?.data?.message || 'Failed to get item'
    notification({ type: 'error', msg: errorMessage })
  }
}

function* updateQuestionClarifiersSaga({
  payload: { testItemId, updatedQuestionData },
}) {
  const assessment = cloneDeep(yield select(getTestEntitySelector))
  const foundItemGroup = assessment.itemGroups.find((itemGroup) => {
    return itemGroup.items.find((item) => item._id === testItemId)
  })

  if (foundItemGroup) {
    const testItem = foundItemGroup.items.find(
      (item) => item._id === testItemId
    )
    const questionIndex = testItem.data.questions.findIndex(
      ({ id }) => id === updatedQuestionData.id
    ) // todo: handle resources
    testItem.data.questions[questionIndex] = updatedQuestionData

    yield put(setTestDataAction({ ...assessment }))
  }
}

function* reviewAiGeneratedRequestSaga({ payload }) {
  try {
    yield call(testItemsApi.reviewAiGeneratedAnswer, payload)
    yield put(reviewAiGeneratedSuccessAction(payload))
  } catch (err) {
    Sentry.captureException(err)
    console.error(err)
    notification({
      type: 'error',
      msg: 'Failed to mark the AI generated answer as reviewed',
    })
  }
}

function* markTestAsReviewedSaga({ payload }) {
  const { testId } = payload || {}
  try {
    const entity = yield select(getTestEntitySelector)
    const itemIds = []
    ;(entity?.itemGroups || []).forEach((group) => {
      ;(group?.items || []).forEach((item) => {
        if (item?.aiGeneratedAnswerReviewed === false) {
          itemIds.push(item._id)
        }
      })
    })

    if (itemIds.length) {
      yield call(testItemsApi.markAiGeneratedAnswersReviewed, { itemIds })
    }

    if (testId && entity?.isReviewRequired) {
      yield call(testsApi.clearReviewRequired, { testIds: [testId] })
    }

    yield put(markTestAsReviewedSuccessAction({ testId }))
  } catch (err) {
    Sentry.captureException(err)
    yield put(markTestAsReviewedFailureAction())
    notification({
      type: 'error',
      msg:
        err?.response?.data?.message ||
        err?.data?.message ||
        'Failed to approve the test. Please try again.',
    })
  }
}

function* submitAITestFeedbackSaga({ payload }) {
  const { testId, rating } = payload

  try {
    yield put(setTestDataAction({ userFeedback: rating }))

    if (testId) {
      yield put(submitAIContentFeedbackRequestAction())
      yield call(testsApi.submitAITestContentFeedback, { testId, rating })
      yield put(submitAIContentFeedbackSuccessAction())
    }
  } catch (err) {
    Sentry.captureException(err)
    yield put(submitAIContentFeedbackErrorAction())
    notification({
      type: 'error',
      msg: 'Could not save your feedback. Please try again.',
    })
  }
}

export function* watcherSaga() {
  yield all([
    takeEvery(RECEIVE_TEST_BY_ID_REQUEST, receiveTestByIdSaga),
    takeEvery(CREATE_TEST_REQUEST, createTestSaga),
    takeEvery(UPDATE_TEST_REQUEST, updateTestSaga),
    Effects.throttleAction(
      process.env.REACT_APP_QA_ENV ? 60000 : 10000,
      UPDATE_TEST_DOC_BASED_REQUEST,
      updateTestDocBasedSaga
    ),
    takeEvery(REGRADE_TEST, updateRegradeDataSaga),
    takeEvery(TEST_SHARE, shareTestSaga),
    takeEvery(TEST_PUBLISH, publishTestSaga),
    takeEvery(RECEIVE_SHARED_USERS_LIST, receiveSharedWithListSaga),
    takeEvery(DELETE_SHARED_USER, deleteSharedUserSaga),
    takeEvery(PREVIEW_CHECK_ANSWER, checkAnswerSaga),
    takeEvery(GET_ALL_TAGS_IN_DISTRICT, getAllTagsSaga),
    takeEvery(SEARCH_TAG_LIST_REQUEST, searchTagsSaga),
    takeEvery(SEARCH_TAGS_BY_IDS_REQUEST, searchTagsByIdSaga),
    takeEvery(PREVIEW_SHOW_ANSWER, showAnswerSaga),
    takeEvery(RECEIVE_DEFAULT_TEST_SETTINGS, getDefaultTestSettingsSaga),
    takeEvery(PUBLISH_FOR_REGRADE, publishForRegrade),
    takeEvery(DUPLICATE_TEST_REQUEST, duplicateTestSaga),
    takeEvery(SET_AND_SAVE_PASSAGE_ITEMS, setAndSavePassageItems),
    takeLatest(UPDATE_TEST_AND_NAVIGATE, updateTestAndNavigate),
    takeEvery(
      APPROVE_OR_REJECT_SINGLE_TEST_REQUEST,
      approveOrRejectSingleTestSaga
    ),
    takeLatest(
      ADD_ITEMS_TO_AUTOSELECT_GROUPS_REQUEST,
      addItemsToAutoselectGroupsSaga
    ),
    takeEvery(SET_TEST_DATA_AND_SAVE, setTestDataAndUpdateSaga),
    takeLatest(TOGGLE_TEST_LIKE, toggleTestLikeSaga),
    takeLatest(GET_TESTID_FROM_VERSIONID, getTestIdFromVersionIdSaga),
    takeLatest(GET_REGRADE_ACTIONS, getRegradeSettingsSaga),
    takeLatest(FETCH_TEST_SETTINGS_LIST, fetchSavedTestSettingsListSaga),
    takeLatest(SAVE_TEST_SETTINGS, saveTestSettingsSaga),
    takeLatest(DELETE_TEST_SETTING_REQUEST, deleteTestSettingRequestSaga),
    takeLatest(UPDATE_TEST_SETTING_REQUEST, updateTestSettingRequestSaga),
    takeLatest(GET_YOUTUBE_THUMBNAIL_REQUEST, getYoutubeThumbnailRequestSaga),
    takeLatest(REPLACE_RESTRICTED_ITEM, replaceRestrictedItemSaga),
    takeLatest(
      DERIVE_AND_SAVE_AUTO_ASSIGN_RULE,
      deriveAndSaveAutoAssignRuleSaga
    ),
    takeLatest(UPDATE_QUESTION_CLARIFIERS, updateQuestionClarifiersSaga),
    takeLatest(REVIEW_AI_GENERATED_REQUEST, reviewAiGeneratedRequestSaga),
    takeLatest(MARK_TEST_AS_REVIEWED_REQUEST, markTestAsReviewedSaga),
    takeLatest(SUBMIT_AI_TEST_FEEDBACK_REQUEST, submitAITestFeedbackSaga),
  ])
}
